//PJQProjectWallAdmin-Master

var validator = null,
	settings = null,
	project = null,
	projectCustomFields = null,
	projContainer = null,
	projContainerCustomFields = null,
	projectStatusList = null,
	messageStatusList = null,
	newsfeedResultIndex = 1,
	newsfeedResultCount = 0,
	newsfeedPageSize = 8,
	pjqKeepAlive = null,
	pjqFirstLoad = true,
	geocoder = null,
	myLatLng = null,
	map = null,
	mapOptions = null,
	partLoaded = false,
	scriptList = [],
	styleList = [],
	sendNewLabel = 'Send New ITB',
	resumeLabel = 'Resume ITB',
	termsLabel = 'Terms',
	dlgUR = null,
	uploadInitUR = false,
	uploadGuidUR = null,
	fileUploadCounter = 0,
	isRFIInit = false,
	isFieldReportsInit = false,
	isSubmittalInit = false,
	isPunchlistInit = false,
	rfiName = "RFI";

function InitProjectWallAdmin() {
	$.mask.definitions['a'] = "[AaPp]";
	$.mask.definitions['m'] = "[Mm]";
	$.mask.definitions['A'] = "[AaBbCcDdEeFfGgHhIiJjKkLlMmNnOoPpQqRrSsTtUuVvWwXxYyZz]";

	let masterTemplate = 'Master',
		sessionMasterUserId = PJQ.app.session.get('masterUserId');
	if (sessionMasterUserId === 118146) {
		masterTemplate += '_118146';
	}
	PJQ.templating.TemplateRenderer.renderTemplate(false, new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALLADMIN, masterTemplate, {isOldModule: true}), jQuery("#pjq-main"), {}, function () {
		jQuery.widget("ui.tabs", $.ui.tabs, {
			_tabKeydown: function (e) {
				return false;
			}
		});

		jQuery('#tabsMain').tabs();

		let rfiNameOverride = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.RFI_NAME_OVERRIDE);
		if (_.size(rfiNameOverride) > 0) {
			rfiName = rfiNameOverride;
			$('#rfiNewButton').text('New ' + rfiName);
			$('#rfiCreateButton').text('Create ' + rfiName);
			$('#li-project-rfi>a').text(rfiName);
		}

		PJQ.templating.TemplateRenderer.renderTemplate(true, new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALLADMIN, 'Procore', {isOldModule: true}), jQuery("#pjq-main"), {}, function () {
			jQuery('#commands button').button();
			jQuery('#procore').button('option', 'icons', {primary: "ui-icon-procore"});
			DisableSave();

			//If ProjectId = -1 , redirect to homepage - PlanExpress Customization
			if (getParameterByName('menuClick') != '' && pjqIsNewProject) {
				window.location.replace(window.location.origin);
			}

			if (pjqIsNewProject) {
				jQuery('#create-new-itb').button('option', 'disabled', true);
				jQuery('#submall-publish').button('option', 'disabled', true);
				jQuery('#copy-project').button('option', 'disabled', true);
				jQuery('#project-insight').button('option', 'disabled', true);
				jQuery('#procore').button('option', 'disabled', true);
				toggleTabs('li-project-home', false);
				jQuery('#project-save').button('option', 'label', 'Create Project');
				jQuery('#project-reload').button('option', 'label', 'Cancel New Project');
			}
			else if (pjqWallContext == 'projcontainer') {
				jQuery('#create-new-itb').addClass('pjq-hidden');
				jQuery('#copy-project').addClass('pjq-hidden');
				jQuery('#submall-publish').addClass('pjq-hidden');
				jQuery('#project-insight').addClass('pjq-hidden');
				jQuery('#procore').addClass('pjq-hidden');
				jQuery('#li-project-home').addClass('pjq-hidden');
				jQuery('#li-project-itb').addClass('pjq-hidden');
				jQuery('#li-project-reports').addClass('pjq-hidden');
				jQuery('#li-project-rfi').addClass('pjq-hidden');
				jQuery('#li-project-contacts').addClass('pjq-hidden');
				jQuery('#li-daily-reports').addClass('pjq-hidden');
				jQuery('#li-photo-gallery').addClass('pjq-hidden');
				jQuery('#li-project-submittals').addClass('pjq-hidden');

				if (pjqIsNewProjContainer)
					toggleTabs('li-project-container', false);

				jQuery('#tabsMain').tabs('option', 'active', 1);
			}

			toggleTabs('', false);


			jQuery('#project-message-recipients').button();
			jQuery('#project-message-send').button();
			jQuery('#project-message-header tr td input.pjq-date-field-width').datepicker({
				showOn: "button",
				numberOfMonths: 3,
				showButtonPanel: true,
				buttonImage: "/i/calendar.png",
				buttonImageOnly: true,
				onSelect: function (name, sender) {
					validator.element('#' + jQuery(sender).attr('id'));
				}

			});

			var projectContactTemp = '';
			var queryString = window.location.search.substring(1);
			var params = queryString.split('&');
			var isDebug = false;
			for (var i = 0; i < params.length; i++) {
				if (params[i].startsWith('pct='))
					projectContactTemp = params[i].substring(4);
				else if (params[i].startsWith('debug='))
					isDebug = true;
				else if (params[i].startsWith('nps=')) {
					if (getParameterByName('projcontainerid'))
						showLeftSideInfo('Record created.<br /><br /><a href="javascript:void(0)" onclick="RawFilesForm()">Upload Raw Files</a>');
					else
						showLeftSideInfo('Project created.<br /><br /><a href="javascript:void(0)" onclick="RawFilesForm()">Upload Raw Files</a>');
				}
				else if (params[i].startsWith('pccf='))
					jQuery('#tabsMain').tabs('option', 'active', 1);
			}
			if (!isDebug)
				window.onScriptError = function () {
				};
			PanteraScript.PanteraScriptService.GetProjectWallAdminSettings(pjqSessionId, projectContactTemp, GetProjectWallAdminSettingsC, onScriptError);

			PJQ.templating.TemplateRenderer.renderTemplate(false, new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALLADMIN, 'ITB', {isOldModule: true}), jQuery("#project-itb"), {}, function () {
				PJQ.templating.TemplateRenderer.renderTemplate(false, new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALLADMIN, 'ProjectDocuments', {isOldModule: true}), jQuery("#project-documents"), {}, function () {
					PJQ.templating.TemplateRenderer.renderTemplate(false, new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALLADMIN, 'ProjectReports', {isOldModule: true}), jQuery("#project-reports"), {}, function () {
						jQuery('#tabsMain').on('tabsactivate', function (event, ui) {
							hideLeftSideInfo();

							jQuery('#procore').addClass('pjq-hidden');
							if (ui.newPanel.attr('id') == 'tabHome') {
								if (settings.IsProcoreEnabled && settings.IsProcoreUserLinked && pjqWallContext == 'project' && !pjqIsNewProject)
									jQuery('#procore').removeClass('pjq-hidden');
							}
							else if (ui.newPanel.attr('id') == 'tabITB') {
								jQuery('#grid-itb').css('width', '100%');
								jQuery('#grid-toolbar-itb').css('width', '100%');
								jQuery('#grid-paging-itb').css('width', '100.3%');
								jQuery('#grid-toolbar-itb-search').css('width', '100%');
								if (gridITB) {
									gridITB.enableAutoHeight(true);
									gridITB.setSizes();
								}
							}
							else {
								jQuery('#create-new-itb,#submall-publish,#project-status').show();
							}
							if (ui.newPanel.attr('id') == 'tabITB') {
								if (!partLoaded) {
									InitializeGridITB(gridITBGroupBy);
								}
								partLoaded = true;
							}
							else if (ui.newPanel.attr('id') == 'tabDocuments') {
								if (typeof PJQProjectWallAdminProjectDocumentsInitialize == 'function')
									PJQProjectWallAdminProjectDocumentsInitialize();
							}
							else if (ui.newPanel.attr('id') == 'tabPhotos') {
								if (typeof PJQProjectWallAdminProjectPhotosInitialize == 'function')
									PJQProjectWallAdminProjectPhotosInitialize();
							}
							else if (ui.newPanel.attr('id') == 'tabReports') {
								if (_.size(jQuery('#report-content .loader')) > 0 && typeof BuildReportProject() == 'function') {
									BuildReportProject();
								}
							}
							else if (ui.newPanel.attr('id') == 'tabProjectContacts') {
								if (!PJQ.app.projectContactsManagement) {
									PJQ.app.projectContactsManagement = new PJQ.views.projectContacts.ProjectContactsManagement({
										el: $("#project-contacts"),
										project: PJQ.app.session.project
									});
								}
							}
							else if (ui.newPanel.attr('id') == 'tabRFI') {
								if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_RFI_NEW)) {
									if (!PJQ.app.RFIManagement) {
										PJQ.app.RFIManagement = new PJQ.views.rfi.RFIManagement({
											el: $('#project-rfi'),
											project: PJQ.app.session.project
										});
									}
								}
								else {
									if (!isRFIInit) {
										initRFITab();
										isRFIInit = true;
									}
								}
							}
							else if (ui.newPanel.attr('id') == 'tabFieldReports') {
								if (!isFieldReportsInit) {
									initFieldReportsTab();
									isFieldReportsInit = true;
								}
							}
							else if (ui.newPanel.attr('id') == 'tabSubmittals') {
								if (!isSubmittalInit) {
									SubmittalListInit($("#project-submittals"));
									isSubmittalInit = true;
								}
							}
							else if (ui.newPanel.attr('id') == 'tabBidForms') {
								if (!PJQ.app.BidFormEditor) {
									initBidFormsAdmin();
								}
							}
							else if (ui.newPanel.attr('id') == 'tabPunchlists') {
								if (!isPunchlistInit) {
									initPunchlistsAdmin();
									isPunchlistInit = true;
								}
							}
							else if (ui.newPanel.attr('id') == 'tabDailyReports') {
								if (!PJQ.app.DailyReportsManagement) {
									initDailyReports();
								}
							}
							else if (ui.newPanel.attr('id') == 'tabPhotoGallery') {
								if (!PJQ.app.ProjectPhotoGallery) {
									PJQ.app.session.project.fetchGalleryPhotos(function (photos) {
										PJQ.app.ProjectPhotoGallery = new PJQ.views.photos.PhotoGallery({
											el: $('#photo-gallery'),
											collection: photos,
											project: PJQ.app.session.project,
										});
									});
								}
							}
						});

						validator = jQuery("Form[name='Form']").validate({
							onsubmit: false,
							onkeyup: false,
							showErrors: function (errorMap, errorList) {
								for (var i = 0; errorList[i]; i++) {
									var element = this.errorList[i].element;
									//solves the problem with brute force
									//remove existing error label and thus force plugin to recreate it
									//recreation == call to error placement function
									this.errorsFor(element).remove();
								}
								this.defaultShowErrors();
							},
							errorPlacement: function (error, element) {
								error.html('<br />' + error.text());
								if (element.attr('tagName') == 'select' || element.hasClass('pjq-numeric-field-width'))
									error.appendTo(element.parent().parent());
								else
									error.appendTo(element.parent());
							},
							errorClass: "pjq-errortext",
							ignore: "pjq-validate-ignore"
						});

						if (!(typeof pjqSendNewLabel === 'undefined') && pjqSendNewLabel.length > 0)
							sendNewLabel = pjqSendNewLabel;

						if (!(typeof pjqResumeLabel === 'undefined') && pjqResumeLabel.length > 0)
							resumeLabel = pjqResumeLabel;

						if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ITB_SEND_NEW_LABEL))
							sendNewLabel = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ITB_SEND_NEW_LABEL);

						if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ITB_RESUME_LABEL))
							resumeLabel = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ITB_RESUME_LABEL);

						if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_MESSAGING_TAB_NAME))
							jQuery('#li-project-itb a').text(PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_WALL_MESSAGING_TAB_NAME));

						if (!PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_BLUE_BOOK_PUBLISH)) {
							let $bbp = $('#blue-book-publish');
							$bbp.removeClass('hidden');
							$bbp.on('click', function () {
								new PJQ.views.projects.BlueBookPublishModal({
									project: PJQ.app.session.project
								});
							});
						}

						if (!(typeof pjqTermsLabel === 'undefined') && pjqTermsLabel.length > 0)
							termsLabel = pjqTermsLabel;

						jQuery('.termsLabel').text(termsLabel);

						let newItbBtn = jQuery('#create-new-itb');
						if (newItbBtn.hasClass('ui-button')) {
							newItbBtn.button('option', 'label', sendNewLabel);
						}
						else {
							newItbBtn.find('.btn-text').text(sendNewLabel);
						}

						pjqKeepAlive = setTimeout(KeepAlive, 300000);
					});
				});
			});
		});
	});
}

function PSChange() {
	PanteraScript.PanteraScriptService.SetProjectStatus(pjqSessionId, jQuery('#project-status').val(), null, onScriptError);
}

function RawFilesForm() {
	if (settings.RawUploadDisable) {
		showInfoDialogPWall('Raw Uploads Disabled', 'Sorry, but Raw File Uploads are disabled for this login.', 'ui-icon-alert');
		return;
	}

	new PJQ.views.files.RawFileUploaderModal();
}

function uploadRevisionInit(response) {
	uploadGuidUR = response;
	var myURL = PJQ.app.options.uploadUrl + '/DesktopModules/PanteraModuleGlobal/FileUpload/FileTransferHandler.ashx?folder=0&uid=' + response + '&sid=' + pjqSessionId;
	jQuery('#fileupload3').attr('action', myURL);
	jQuery('#fileupload3').fileupload();
	jQuery('#fileupload3').fileupload('option', {
		autoUpload: true,
		url: myURL,
		dropZone: jQuery('#fileupload3')
	});

	jQuery("#raw-files table[role='presentation'] tbody tr").remove();
	if (!(pjqIsIE || (pjqBrowserVersion == 11 && navigator.userAgent.indexOf("rv:11") != -1)))
		jQuery('#raw-files div.dropnotice').show();

	jQuery('#upload-revision-continue', jQuery('#fileupload3')).prop('disabled', true);
	jQuery('#upload-revision-continue', jQuery('#fileupload3')).addClass('ui-button-disabled');
	jQuery('#upload-revision-continue', jQuery('#fileupload3')).addClass('ui-state-disabled');


	if (!uploadInitUR) {

		jQuery('#fileupload3').bind('fileuploadstop', function (e, data) {
			jQuery('#upload-revision-continue', jQuery('#fileupload3')).prop('disabled', false);
			jQuery('#upload-revision-continue', jQuery('#fileupload3')).removeClass('ui-button-disabled');
			jQuery('#upload-revision-continue', jQuery('#fileupload3')).removeClass('ui-state-disabled');
		});
		jQuery('#fileupload3').bind('fileuploadstart', function (e, data) {
			jQuery('#upload-revision-continue', jQuery('#fileupload3')).prop('disabled', true);
			jQuery('#upload-revision-continue', jQuery('#fileupload3')).addClass('ui-button-disabled');
			jQuery('#upload-revision-continue', jQuery('#fileupload3')).addClass('ui-state-disabled');
		});
		jQuery('#fileupload3').bind('fileuploaddestroy', function (e, data) {
			if (jQuery("#raw-files table[role='presentation'] tbody tr").length < 2) {
				jQuery('#upload-revision-continue', jQuery('#fileupload3')).prop('disabled', true);
				jQuery('#upload-revision-continue', jQuery('#fileupload3')).addClass('ui-button-disabled');
				jQuery('#upload-revision-continue', jQuery('#fileupload3')).addClass('ui-state-disabled');
			}
			else {
				jQuery('#upload-revision-continue', jQuery('#fileupload3')).prop('disabled', false);
				jQuery('#upload-revision-continue', jQuery('#fileupload3')).removeClass('ui-button-disabled');
				jQuery('#upload-revision-continue', jQuery('#fileupload3')).removeClass('ui-state-disabled');
			}
		});

		if (pjqIsIE || (pjqBrowserVersion == 11 && navigator.userAgent.indexOf("rv:11") != -1)) {
			jQuery('#ur-dragdrop-notice').text('Files Attached:');
			jQuery('#raw-files').css('border', 'solid 1px black');
			jQuery('#raw-files div.dropnotice').addClass('pjq-hidden');
			jQuery('#raw-files div.dropnotice').css('display', 'none');
			jQuery('#if-upload-private3').removeClass('pjq-hidden');
		}
		else
			jQuery('#if-upload-private3').addClass('pjq-hidden');
	}

	dlgUR = jQuery("#raw-files-upload").dialog({
		modal: true,
		resizable: true,
		title: 'Upload Raw Files',
		width: 800,
		height: 400,
		buttons: {}
	});

	uploadInitUR = true;
}

function uploadRevisionCompletePW() {
	dlgUR.dialog('close');
	PanteraScript.PanteraScriptService.ProcessRevisionUpload(pjqSessionId, uploadGuidUR, 0, jQuery('#ur-revision-name').val(), jQuery('#ur-docclerk-notes').val(), uploadRevisionC, onScriptError);
}

function uploadRevisionC(response) {
	if (response.startsWith('SUCCESS')) {
		showInfoDialogPWall('Upload Success', 'Your Raw Files have been uploaded successfully.  Your confirmation # is ' + response.substring(response.indexOf('|') + 1) + '.');
	}
	else
		showInfoDialogPWall('Upload Failed', 'Sorry, we were unable to process your upload.  Please contact Customer Service at 877-219-9777 or customerservice@panteratools.com', 'ui-icon-alert');
}

function ProjectInsight() {
	var url = settings.ProjectInsightBaseURL + '/Content/Pantera/ProjectIntegration.aspx?pt_pid=' + project.ProjectId.toString() + '&pt_sid=' + pjqSessionId;
	window.location.href = url;
}

function GetProjectWallAdminSettingsC(response) {
	settings = jQuery.parseJSON(response);

	toggleTabs('', true);

	if (pjqIsNewProject) {
		toggleTabs('li-project-home', false);
	}
	else if (pjqIsNewProjContainer) {
		toggleTabs('li-project-container', false);
	}
	else
		jQuery('#create-new-itb').button('enable');

	if (pjqWallContext != 'projcontainer') {

		jQuery('#project-status').val(settings.DocClerkStatus);
		if (settings.IsDocumentClerk)
			jQuery('#project-status').removeClass('pjq-hidden');

		if (settings.IsCopyProject && pjqWallContext == 'project')
			jQuery('#copy-project').removeClass('pjq-hidden');

		if (settings.IsProjectPublishedSubmall)
			jQuery('#submall-publish').button('option', 'label', 'Edit Sub Mall');

		if (settings.IsProjectInsightEnabled && pjqWallContext == 'project' && !pjqIsNewProject)
			jQuery('#project-insight').removeClass('pjq-hidden');

		let prefs = PJQ.app.session.preferences;
		if (prefs.hasPref(PJQ.constants.preferenceTypes.ENABLE_BID_FORMS))
			jQuery('#li-project-bidForms').show();

		if (prefs.hasPref(PJQ.constants.preferenceTypes.ENABLE_FIELD_REPORTS))
			jQuery('#li-project-field-reports').show();

		jQuery('#li-project-submittals').show();

		if (prefs.hasPref(PJQ.constants.preferenceTypes.ENABLE_PUNCH_LISTS))
			jQuery('#li-project-punchlist').show();

		if (!prefs.hasPref(PJQ.constants.preferenceTypes.DISABLE_RFI))
			jQuery('#li-project-rfi').show();

		if (!prefs.hasPref(PJQ.constants.preferenceTypes.DISABLE_DAILY_REPORTS)) {
			jQuery('#li-daily-reports').show();
			jQuery('#li-photo-gallery').show();
		}

		if (settings.IsProcoreEnabled && settings.IsProcoreUserLinked && pjqWallContext == 'project' && !pjqIsNewProject)
			jQuery('#procore').removeClass('pjq-hidden');

	}

	if (typeof PJQProjectWallAdminITBInitialize == 'function' && !pjqIsNewProject) {
		var xmlFile = '/DesktopModules/PJQProjectWallAdmin/GetProjectMessageTemplates.aspx?sessionid=' + pjqSessionId + '&x=' + (new Date).getTime();

		jQuery.ajax({
			type: "GET",
			url: xmlFile,
			dataType: "json",
			success: function (result) {
				settings.ProjectMessageTemplates = result;

				PJQProjectWallAdminITBInitialize();
			}
		});

	}

	if (settings.IsProjContainerEnabled) {
		jQuery('#li-project-container a').text(settings.ProjContainerLabel + ' Home');
		jQuery('#li-project-container').removeClass('pjq-hidden');


		if (pjqIsNewProjContainer) {
			jQuery('#project-save').button('option', 'label', 'Create ' + settings.ProjContainerLabel);
			jQuery('#project-reload').button('option', 'label', 'Cancel New ' + settings.ProjContainerLabel);
		}
	}
	if (settings.IsArchitect) {
		jQuery('#create-new-itb').addClass('pjq-hidden');
		jQuery('#copy-project').addClass('pjq-hidden');
		jQuery('#submall-publish').addClass('pjq-hidden');
		jQuery('#project-insight').addClass('pjq-hidden');
		jQuery('#li-project-itb').addClass('pjq-hidden');
		jQuery('#li-project-documents').addClass('pjq-hidden');
		jQuery('#li-project-reports').addClass('pjq-hidden');
		jQuery('#li-project-container').addClass('pjq-hidden');
	}

	if (settings.IsDownloadTermsEnabled) {
		jQuery('#li-project-terms').show();
		jQuery('#projectTermsText').val(settings.DownloadTerms);
	}

	if (pjqWallContext == 'project') {
		PanteraScript.PanteraScriptService.GetProjectInfo(pjqSessionId, ProjectInfoC, onScriptError);
	}

	if (settings.IsProjContainerEnabled)
		PanteraScript.PanteraScriptService.GetProjectContainerInfo(pjqSessionId, ProjContainerInfoC, onScriptError);

	if (typeof PJQProjectWallAdminProjectReportsInitialize == 'function' && !pjqIsNewProject && pjqWallContext == 'project')
		PJQProjectWallAdminProjectReportsInitialize();

	var queryString = window.location.search.substring(1);
	var params = queryString.split('&');
	var isDebug = false;
	for (var i = 0; i < params.length; i++) {
		if (params[i].startsWith('npc='))
			showLeftSideInfo(settings.ProjContainerLabel + ' created.<br />');
	}

	if (getParameterByName('pcr') == 'true') {
		activateTab('li-project-contacts');
	}
	else if (window.punchListItemId > 0) {
		activateTab('li-project-punchlist');
	}
	else if (window.dailyReportDate != null) {
		activateTab('li-daily-reports');
	}

	updateRFINotificationCounter();
}

function ReedProject() {
	var url = '/Default.aspx?tabId=' + settings.ReedProjectWallTabId.toString() + '#' + project.ExternalProjectId + '-REED';
	window.location.href = url;
}

function ProjectInfoC(response) {
	project = jQuery.parseJSON(response);

	if (settings.IsPlanExpressPortal && window.project.ProjectStatus.toLowerCase() === "ready") {
		jQuery('#order-documents').show();
	}

	if (typeof pjqRFILoadId !== 'undefined' && pjqRFILoadId > 0) {
		isRFIInit = true;
		initRFITab();
	}
	else if (getParameterByName('fr') != '') {
		setTimeout(function () {
			activateTab('li-project-field-reports');
		}, 250);
	}
	else if (getParameterByName('subid') != '') {
		setTimeout(function () {
			activateTab('li-project-submittals');
		}, 250);
	}
	else if (getParameterByName('punchid') != '') {
		setTimeout(function () {
			activateTab('li-project-punchlist');
		}, 250);
	}
	else if (settings.IsBidFormsEnabled && _.size(getParameterByName('proposal')) > 0) {
		activateTab('li-project-bidForms');
	}

	var projectLocation = "";
	if (project.Address1)
		projectLocation = project.Address1;

	if (project.Address2) {
		if (projectLocation)
			projectLocation = projectLocation + "<br />";

		projectLocation = projectLocation + project.Address2;
	}

	if (project.City || project.StateProvince || project.PostalCode) {
		var cityStateZip = "";

		if (project.City)
			cityStateZip = project.City;

		if (project.StateProvince) {
			if (project.City)
				cityStateZip = cityStateZip + ", ";
			cityStateZip = cityStateZip + project.StateProvince;

		}

		if (project.PostalCode) {
			if (cityStateZip)
				cityStateZip = cityStateZip + " ";

			cityStateZip = cityStateZip + project.PostalCode;
		}

		if (projectLocation)
			projectLocation = projectLocation + "<br />";

		projectLocation = projectLocation + cityStateZip;
	}
	var bidDueTime = "";
	if (project.ResponseDue != "ASAP" &&
		project.ResponseDueTime.length > 0 &&
		project.ResponseDueTime[0] != ' ')
		bidDueTime = project.ResponseDueTime;

	if (bidDueTime)
		bidDueTime = bidDueTime + "&nbsp;" + project.ResponseDueTimeZone;

	var projectName = project.ProjectName;
	if (pjqIsNewProject) {
		projectName = 'New Project';
		bidDueTime = 'N/A';
	}

	var template = "<div class='projectheader-projectname text-dark'>" + projectName + "</div>";
	template += "<div class='projectheader-biddue text-dark'><span class='font-weight-light'>" + settings.ProjectResponseDueLabel + ":</span>&nbsp;" + project.ResponseDue + "&nbsp;" + bidDueTime + "</div>";
	template += "<br /><div class='projectheader-projectlocation text-dark font-weight-light'>" + projectLocation + "</div>";
	template += "<div class='projectheader-mapicon'><img id='ProjectMapIcon2' src='/i/map.png' onclick='ShowMap()' /></div>";
	var projectHeaderTemplate = $.templates(template);
	jQuery("#ProjectHeader").html(projectHeaderTemplate.render());

	if (project.ProjectType === 'REED_COPY')
		jQuery('#reed-project').removeClass('pjq-hidden');

	let phTemplate = 'ProjectHome',
		sessionMasterUserId = PJQ.app.session.get('masterUserId');
	if (sessionMasterUserId === 23) {
		phTemplate += '_23';
	}
	else if (sessionMasterUserId === 97410) {
		phTemplate += '_97410';
	}
	PJQ.templating.TemplateRenderer.renderTemplate(false, new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALLADMIN, phTemplate, {
		isOldModule: true,
		isJsRender: true
	}), jQuery("#project-home"), _.defaults(project, settings), function () {
		if (typeof PJQProjectWallAdminProjectHomeInitialize == 'function')
			PJQProjectWallAdminProjectHomeInitialize();

		if (project.ExternalProjectId && project.ExternalProjectId.indexOf('PROCORE') != -1) {
			jQuery('#procore').button('option', 'label', 'Published');
			//jQuery('#procore').button('option', 'disabled', true);
		}

		if (settings.IsProjectHomeReadonly)
			ProjectHomeDisable();

		let request = new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'v1'
				},
				{
					endpoint: 'projects',
					value: project.ProjectId == null ? 0 : project.ProjectId
				},
				{
					endpoint: 'customfields'
				}
			])
		});
		request.get().done(_.bind(function (data) {
			ProjectCustomFieldInfoC(data);
		}, this)).fail(function () {
			//todo: hide loading and create error toast
		});
	});
}

function ProjContainerInfoC(response) {
	projContainer = jQuery.parseJSON(response);

	var projectLocation = "";
	if (settings.IsProjContainerLocEnabled) {
		if (projContainer.Address1)
			projectLocation = projContainer.Address1;

		if (projContainer.Address2) {
			if (projectLocation)
				projectLocation = projectLocation + "<br />";

			projectLocation = projectLocation + projContainer.Address2;
		}

		if (projContainer.City || projContainer.StateProvince || projContainer.PostalCode) {
			var cityStateZip = "";

			if (projContainer.City)
				cityStateZip = projContainer.City;

			if (projContainer.StateProvince) {
				if (projContainer.City)
					cityStateZip = cityStateZip + ", ";
				cityStateZip = cityStateZip + projContainer.StateProvince;
			}

			if (projContainer.PostalCode) {
				if (cityStateZip)
					cityStateZip = cityStateZip + " ";

				cityStateZip = cityStateZip + projContainer.PostalCode;
			}

			if (projectLocation)
				projectLocation = projectLocation + "<br />";

			projectLocation = projectLocation + cityStateZip;
		}
	}
	var projectName = projContainer.ProjectContainerName;
	if (pjqIsNewProjContainer) {
		projectName = 'New ' + settings.ProjContainerLabel;
	}

	if (pjqWallContext == 'projcontainer') {
		var template = "<div class='projectheader-projectname text-dark'>" + projectName + "</div>";
		template += "<br /><div class='projectheader-projectlocation text-dark font-weight-light'>" + projectLocation + "</div>";
		template += "<div class='projectheader-mapicon'><img id='ProjectMapIcon2' src='/i/map.png' onclick='ShowMap()' /></div>";
		var projectHeaderTemplate = $.templates(template);

		jQuery("#ProjectHeader").html(projectHeaderTemplate.render());
	}

	let pcTemplate = 'ProjectContainerHome',
		sessionMasterUserId = PJQ.app.session.get('masterUserId');
	if (sessionMasterUserId === 283507) {
		pcTemplate += '_283507';
	}

	PJQ.templating.TemplateRenderer.renderTemplate(false, new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALLADMIN, pcTemplate, {
		isOldModule: true,
		isJsRender: true
	}), jQuery("#project-container-home"), _.defaults(projContainer, settings), function () {
		if (typeof PJQProjectWallAdminProjContainerInitialize == 'function')
			PJQProjectWallAdminProjContainerInitialize();

		PanteraScript.PanteraScriptService.GetProjectContainerCustomFieldInfoAdmin(pjqSessionId, ProjContainerCustomFieldInfoC, onScriptError);
	});
}

function ProjContainerCustomFieldInfoC(response) {
	projContainerCustomFields = jQuery.parseJSON(response);

	if (typeof ProjContainerCustomFieldsInitialize == 'function')
		ProjContainerCustomFieldsInitialize();
}

function ProjectCustomFieldInfoC(response) {
	projectCustomFields = response;

	if (typeof PJQProjectWallAdminProjectCustomFieldsInitialize == 'function')
		PJQProjectWallAdminProjectCustomFieldsInitialize();


	if (!pjqFirstLoad) {
		if (!pjqIsNewProject)
			showLeftSideInfo('Project reloaded.');
		jQuery('#project-newsfeed').html('<div class="loader m-0a" style="margin-top: 30px;"></div>');
		newsfeedResultIndex = 1;
		newsfeedResultCount = 0;
		newsfeedPageSize = 8;
	}

	//PanteraScript.PanteraScriptService.GetProjectNewsfeedAdmin(pjqSessionId, newsfeedResultIndex, newsfeedPageSize, NewsfeedC, onScriptError);
	var xmlFile = '/DesktopModules/PJQProjectWallAdmin/GetNewsfeed.aspx?sessionid=' + pjqSessionId + '&pn=' + newsfeedResultIndex.toString() + '&ps=' + newsfeedPageSize.toString() + '&x=' + (new Date).getTime();

	jQuery.ajax({
		url: xmlFile,
		success: function (result) {
			NewsfeedC(result);
		},
		error: function (xhr, status, error) {
			showInfoDialogPWall('Export Error', "An error occurred during newsfeed generation: " + error, 'ui-icon-alert');
		}
	});

	if (typeof PJQProjectWallAdminProjectNewsfeedInitialize == 'function')
		PJQProjectWallAdminProjectNewsfeedInitialize();

	$("input[type='text']").keydown(function (event) {
		if (event.keyCode == 13 && !jQuery(this).hasClass('inp')) {
			event.preventDefault();
			return false;
		}
	});

	pjqFirstLoad = false;

	if (settings.IsProjectHomeReadonly)
		ProjectHomeDisable();

}

function SendNewITB() {
	ShowProjectMessageDialog(settings.DefaultPMTemplateKey);
}

function pjqDL(id) {
	if (settings.DisableDownload) {
		if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_NEW_FILE_VIEWER)) {
			new PJQ.views.files.FileViewer({
				model: new PJQ.models.files.File({entryId: id}),
				isDisableDownload: true
			});
		}
		else {
			window.open('https://docs.panteratools.com/DesktopModules/PanteraModuleGlobal/DocView.aspx?e=' + id.toString() + '&c=0&o=' + settings.MasterUserId.toString() + '&p=' + settings.PortalId.toString(), '_blank', 'resizable=1,toolbar=1,location=1,directories=1,addressbar=1,scrollbars=1,status=1,menubar=1,top=0,left=0,screenX=' + window.screenLeft + ', screenY=' + window.screenTop + ', width=' + (screen.availWidth - 20) + ',height=' + (screen.availHeight - 122));
		}
	}
	else {
		PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'files',
				value: id
			},
			{
				endpoint: 'downloadentryid'
			}
		]), {
			isEndpoint: true,
			isApi2: true
		});
	}
	return false;
}

function DownloadFile(path) {
	if (pjqIsIOS) {
		window.open(path);
	}
	else {
		var ifr = "<iframe src='" + path + "' frameborder='0' height='0' width='0'><a href='" + path + "'>Click here if your download does not start automatically.</a></iframe>";
		jQuery('#download-iframe').html('');
		jQuery('#download-iframe').append(ifr);
	}
}

function NewsfeedC(response) {
	// get data from rseponse
	var news = [];
	if (response)
		news = jQuery.parseJSON(response);

	if (news.length > 0) {
		newsfeedResultCount = news[0].ResultCount;
		if (news[0].ResultCount <= newsfeedResultIndex * newsfeedPageSize)
			newsfeedResultCount = -1;

		newsfeedResultIndex = newsfeedResultIndex + 1;
	}
	else
		newsfeedResultCount = -1;

	isNewsfeedLoading = false;

	var $nlDivHtml = "<div id='newsfeed-loading'>" + jQuery('#newsfeed-loading').html() + "</div>";
	jQuery('#newsfeed-loading').remove();

	if (news.length == 0) {
		return;
	}

	jQuery('.newsfeed-last').removeClass('newsfeed-last');

	PJQ.templating.TemplateRenderer.renderTemplate(true, new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALLADMIN, 'ProjectNewsfeed', {
		isOldModule: true,
		isJsRender: true
	}), jQuery("#project-newsfeed"), news, function () {
		jQuery('b.newsfeed-respdue').text(settings.MessageResponseDueLabel + ':');

		if (newsfeedResultCount > 0)
			jQuery("#project-newsfeed").append($nlDivHtml);
	});
}

function copyProjectC(response) {
	var url = '/Default.aspx?tabId=' + settings.ProjectWallTabId.toString() + '&projectid=' + response;
	window.location.href = url;
}

function UpdateFileCounter() {
	fileUploadCounter = fileUploadCounter + 1;
}

function KeepAlive() {
	clearTimeout(pjqKeepAlive);
	jQuery.get('/DesktopModules/PanteraModuleGlobal/KeepAlive.aspx');
	pjqKeepAlive = setTimeout(KeepAlive, 300000);
}

function EnableSave() {
	if (PJQ.app.module === PJQ.constants.modules.APP) {
		jQuery('#project-save').prop('disabled', false);
	}
	else {
		jQuery('#project-save, #project-reload').button('option', 'disabled', false);
		jQuery('#project-save span').css('font-weight', 'bold');
		jQuery('#project-save').css('border', 'solid 1px red');
		jQuery('#left-side-info').addClass('pjq-hidden');
		if (!pjqIsNewProject) {
			jQuery('#create-new-itb').button('option', 'disabled', true);
			jQuery('#submall-publish').button('option', 'disabled', true);
			jQuery('#project-insight').button('option', 'disabled', true);
			jQuery('#procore').button('option', 'disabled', true);
			jQuery('#copy-project').button('option', 'disabled', true);
			toggleTabs('', true);
		}
	}
	return true;
}

function EnableSaveP() {
	if (PJQ.app.module === PJQ.constants.modules.APP) {
		jQuery('#project-save').prop('disabled', false);
	}
	else {
		jQuery('#project-save, #project-reload').button('option', 'disabled', false);
		jQuery('#project-save span').css('font-weight', 'bold');
		jQuery('#project-save').css('border', 'solid 1px red');
		jQuery('#left-side-info').addClass('pjq-hidden');
		if (!pjqIsNewProject) {
			jQuery('#create-new-itb').button('option', 'disabled', true);
			jQuery('#submall-publish').button('option', 'disabled', true);
			jQuery('#project-insight').button('option', 'disabled', true);
			jQuery('#procore').button('option', 'disabled', true);
			jQuery('#copy-project').button('option', 'disabled', true);
			toggleTabs('', true);
		}
	}
	return true;
}

function DisableSave() {
	if (!PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.NEW_APP_PORTAL)) {
		jQuery('#project-save span').css('font-weight', '');
		jQuery('#project-save').css('border', '');
		jQuery('#project-save').button('option', 'disabled', true);
		if (!pjqIsNewProject && !pjqIsNewProjContainer) {
			jQuery('#project-reload').button('option', 'disabled', true);
			if (settings != null)
				jQuery('#create-new-itb').button('option', 'disabled', false);
			jQuery('#submall-publish').button('option', 'disabled', false);
			jQuery('#project-insight').button('option', 'disabled', false);

			if (project && project.ExternalProjectId && project.ExternalProjectId.indexOf('PROCORE') != -1)
				jQuery('#procore').button('option', 'disabled', false);

			jQuery('#copy-project').button('option', 'disabled', false);

			jQuery('#tabsMain').tabs('option', 'disabled', []);
		}
	}
}

function ProjectResponseDueChanged() {
	jQuery('div.projectheader-biddue').html('<b>' + settings.ProjectResponseDueLabel + ':</b>&nbsp;' + jQuery('#project-response-due').val() + '&nbsp;' + jQuery('#project-response-due-time').val() + '&nbsp;' + jQuery('#project-response-due-timezone').val());
	EnableSaveP();
}

function ProjectLocationChanged() {
	EnableSaveP();
	var projectLocation = "";
	if (jQuery('#project-address1').val())
		projectLocation = jQuery('#project-address1').val();

	if (jQuery('#project-address2').val()) {
		if (projectLocation)
			projectLocation = projectLocation + "<br />";

		projectLocation = projectLocation + jQuery('#project-address2').val();
	}

	var stateProvince = jQuery('#project-state-us').val();
	if (!stateProvince)
		stateProvince = jQuery('#project-state-ca').val();

	if (jQuery('#project-city').val() || stateProvince || jQuery('#project-zip').val()) {
		var cityStateZip = "";

		if (jQuery('#project-city').val())
			cityStateZip = jQuery('#project-city').val();

		if (stateProvince) {
			if (jQuery('#project-city').val())
				cityStateZip = cityStateZip + ", ";
			cityStateZip = cityStateZip + stateProvince;

		}

		if (jQuery('#project-zip').val()) {
			if (cityStateZip)
				cityStateZip = cityStateZip + " ";

			cityStateZip = cityStateZip + jQuery('#project-zip').val();
		}

		if (projectLocation)
			projectLocation = projectLocation + "<br />";

		projectLocation = projectLocation + cityStateZip;
	}

	jQuery('div.projectheader-projectlocation').html(projectLocation);
}

function ProjectSave() {
	if (jQuery("#tabsMain .ui-tabs-panel:visible").attr("id") == 'tabHome' || jQuery("#tabsMain .ui-tabs-panel:visible").attr("id") == 'tabTerms') {
		if (SaveProject()) {
			DisableSave();
		}
	}
	else if (jQuery("#tabsMain .ui-tabs-panel:visible").attr("id") == 'tabProjectContainer') {
		if (SaveProjContainer()) {
			DisableSave();
		}
	}
}

function showLeftSideInfo(message, iconClass) {
	if (iconClass)
		jQuery('#left-message-icon').addClass(iconClass);
	else
		jQuery('#left-message-icon').addClass('ui-icon-info');
	jQuery('#left-message-span').html(message);
	jQuery('#left-side-info').removeClass('pjq-hidden');
}

function hideLeftSideInfo() {
	jQuery('#left-side-info').addClass('pjq-hidden');
}

function ProjectReload() {
	if (pjqIsNewProject || pjqIsNewProjContainer) {
		var url = '/Default.aspx?tabId=' + settings.ProjectListTabId.toString();
		window.location.href = url;
	}
	else {
		DisableSave();
		if (0 == jQuery('#tabsMain').tabs('option', 'active')) {
			jQuery('#project-home').html('<div class="loader m-0a" style="margin-top: 30px;"></div>');
			PanteraScript.PanteraScriptService.GetProjectInfo(pjqSessionId, ProjectInfoC, onScriptError);
		}
		else {
			jQuery('#projcontainer-home').html('<div class="loader m-0a" style="margin-top: 30px;"></div>');
			PanteraScript.PanteraScriptService.GetProjectContainerInfo(pjqSessionId, ProjContainerInfoC, onScriptError);
		}
	}
}

function showInfoDialogPWall(titleText, message, iconClass, context) {
	if (iconClass)
		jQuery('#dialog-message-icon').addClass(iconClass);
	else
		jQuery('#dialog-message-icon').addClass('ui-icon-info');

	jQuery('#dialog-message-context').val(context);

	jQuery('#dlg-message-span').html(message);
	var buttonList = {
		Ok: function () {
			$(this).dialog("close");
		}
	};
	if (context == 'clear-search-itb' || context == 'delete-contacts-itb' || context == 'delete-contact-itb' || context == 'delete-message-itb' || context == 'resend-contacts-itb' || context == 'resend-contact-itb' || context == 'delete-project-comment' || context == 'delete-project-message' || context == 'delete-intmessages' || context == 'detach-folder-pdocs' || context == 'delete-pdocs' || context == 'delete-contacts-pccf' || context == 'copy-project' || context == 'detach-projcontainer' || context == 'delete-contact-group-itb' || context == 'project-status-change' || context == 'request-prequal' || context == 'request-prequal-project' || context == 'set_response_multiple' || context == 'delete-contacts-pccf' || context == 'delete-contacts-pcf' || context == 'filter-unsent' || context == 'delete-field-report-permission' || context == 'delete-field-report' || context == 'delete-field-report-data-list' || context == 'send-itb-statusreset' || context == 'delete-submittal' || context == 'contact-updater' || context == 'duplicate-email') {
		buttonList = {
			Ok: function () {
				var context = jQuery('#dialog-message-context').val();
				if (context == 'delete-contacts-itb') {
					if (typeof DeleteContactsITB == 'function')
						DeleteContactsITB();
				}
				else if (context == 'delete-contact-itb') {
					if (typeof DeleteContactITB == 'function')
						DeleteContactITB();
				}
				else if (context == 'delete-contacts-pccf') {
					if (typeof DeleteContactPCCF == 'function')
						DeleteContactPCCF();
				}
				else if (context == 'delete-contacts-pcf') {
					if (typeof DeleteContactPCF == 'function')
						DeleteContactPCF();
				}
				else if (context == 'clear-search-itb') {
					if (typeof FilterClearAllClick == 'function')
						FilterClearAllClick();
				}
				else if (context == 'delete-message-itb') {
					if (typeof DeleteMessageITB == 'function')
						DeleteMessageITB();
				}
				else if (context == 'resend-contacts-itb') {
					if (typeof ResendContactsITB == 'function')
						ResendContactsITB();
				}
				else if (context == 'resend-contact-itb') {
					if (typeof ResendContactITB == 'function')
						ResendContactITB();
				}
				else if (context == 'delete-project-comment') {
					if (typeof DeleteProjectCommentId == 'function')
						DeleteProjectCommentId();
				}
				else if (context == 'delete-project-message') {
					if (typeof DeleteProjectMessageByCommentId == 'function')
						DeleteProjectMessageByCommentId();
				}
				else if (context == 'delete-intmessages') {
					if (typeof DeleteInternalMessages == 'function')
						DeleteInternalMessages();
				}
				else if (context == 'detach-folder-pdocs') {
					if (typeof DetachSharedFolder == 'function')
						DetachSharedFolder();
				}
				else if (context == 'delete-pdocs') {
					if (typeof DeletePDocs == 'function')
						DeletePDocs();
				}
				else if (context == 'copy-project') {
					PanteraScript.PanteraScriptService.CopyProject(pjqSessionId, 0, copyProjectC, onScriptError);
				}
				else if (context == 'detach-projcontainer') {
					DetachProjContainer();
				}
				else if (context == 'delete-contact-group-itb') {
					DeleteContactGroup();
				}
				else if (context == 'project-status-change') {
					ProjectStatusChangeFinal();
				}
				else if (context == 'request-prequal') {
					RequestContactPrequalification();
				}
				else if (context == 'request-prequal-project') {
					RequestProjectContactPrequalification();
				}
				else if (context == 'set_response_multiple') {
					InitializeSetResponseMultiple();
				}
				else if (context == 'filter-unsent') {
					FilterClearAll();
					FilterUnsent();
				}
				else if (context == 'delete-field-report-permission') {
					DeleteFieldReportPermission();
				}
				else if (context == 'delete-field-report') {
					DeleteFieldReport();
				}
				else if (context == 'delete-field-report-data-list') {
					DeleteFieldReportGridRow();
				}
				else if (context == 'send-itb-statusreset') {
					SendPM2();
				}
				else if (context == 'delete-submittal') {
					DeleteSubmittal();
				}
				else if (context == 'contact-updater') {
					SendContactUpdater();
				}
				else if (context == 'duplicate-email') {
					myInfoSave(lastSaveContext, lastIsAddToProject, true);
				}
				$(this).dialog("close");
			},
			Cancel: function () {
				if (context == 'project-status-change') {
					ProjectStatusChangeCancel();
				}
				else if (context == 'send-itb-statusreset') {
					jQuery('#project-message-window').parent().show();
				}
				$(this).dialog("close");
			}
		};
	}
	else if (context == 'no-buttons') {
		buttonList = {};
	}

	jQuery("#dialog-message").dialog({
		modal: true,
		title: titleText,
		buttons: buttonList
	});

	return jQuery("#dialog-message");
}

function mediaTypeChanged() {
	if (jQuery('#rOrderPrint').prop("checked"))
		jQuery('tr.print-option td').css('display', '');
	else
		jQuery('tr.print-option td').css('display', 'none');
}

function SubMall() {
	// todo: validate?
	var url = "/Default.aspx?tabId=" + settings.ProjectPublishTabId.toString() + "&step=3&s=" + pjqSessionId;
	if (settings.IsProjectPublishedSubmall)
		url = "/Default.aspx?tabId=" + settings.ProjectPublishTabId.toString() + "&step=5&s=" + pjqSessionId;
	window.location.href = url;
}

function CopyProject() {
	showInfoDialogPWall('Copy Project', 'Are you sure you want to Copy this Project?', 'ui-icon-alert', 'copy-project');
}

function ShowBusy(message) {
	jQuery('#tabsMain').tabs('disable');
	jQuery('#pjq-busy').html('<div class="loader m-0a" style="margin-top: 30px;"></div>');
	jQuery("#pjq-busy").removeClass('pjq-hidden');
}

function HideBusy() {
	jQuery("#pjq-busy").addClass('pjq-hidden');
	jQuery('#tabsMain').tabs('enable');
}

function ShowMap() {
	if (null == map) {
		map = new google.maps.Map(document.getElementById('map_canvas'), mapOptions);

		var address = jQuery('div.projectheader-projectlocation').text();
		var markerTitle = jQuery('div.projectheader-projectname').text() + '\n' + address;
		geocoder.geocode({
			'address': address
		}, function (results, status) {
			if (status == google.maps.GeocoderStatus.OK) {
				map.setCenter(results[0].geometry.location);
				myLatLng = results[0].geometry.location;
				var marker = new google.maps.Marker({
					map: map,
					title: markerTitle,
					position: results[0].geometry.location
				});
			}
			else {
				alert("Unable to find Project Location for the following reason: " + status);
			}
		});
	}
	else {
		map.getStreetView().setVisible(false);
		map.setMapTypeId(google.maps.MapTypeId.SATELLITE);
		map.setZoom(15);
		map.setCenter(myLatLng);

	}
	jQuery('#ProjectMap').dialog({
		resizable: false,
		movable: false,
		height: 505,
		width: 650,
		modal: true,
		buttons: {
			"Center Map on Project": function () {
				map.setCenter(myLatLng)
			},
			"Close Map": function () {
				jQuery(this).dialog("close")
			}
		}
	});
}

jQuery.fn.outerHTML = function (s) {
	return s ? this.before(s).remove() : jQuery("<p>").append(this.eq(0).clone()).html();
};

function ValidateDate(input) {
	return /^\d{1,2}?\/\d{1,2}?\/\d{4}?$/i.test(input);
}

function ClearValidationError(id) {
	jQuery(id).removeClass('pjq-errortext');
	jQuery('label.pjq-errortext', jQuery(id).parent()).remove();
}

function SetValidationError(id, text) {
	jQuery(id).parent().append("<label class='pjq-errortext'>" + text + "</label>");
	jQuery(id).addClass('pjq-errortext');
}

/*
dhtmlxError.catchError("LoadXML", function(a, b, data) {
  //data[0] - request object
  //data[0].responseText - incorrect server side response
});
*/

function TranslateTokens(template) {
	var tokens = [{find: '\\[Sender.Username\\]', replace: '{{:Sender.Username}}'},
		{find: '\\[Sender.Company\\]', replace: '{{:Sender.Company}}'},
		{find: '\\[Sender.Contact\\]', replace: '{{:Sender.Contact}}'},
		{find: '\\[Sender.Address1\\]', replace: '{{:Sender.Address1}}'},
		{find: '\\[Sender.Address2\\]', replace: '{{:Sender.Address2}}'},
		{find: '\\[Sender.City\\]', replace: '{{:Sender.City}}'},
		{find: '\\[Sender.State\\]', replace: '{{:Sender.State}}'},
		{find: '\\[Sender.Zip\\]', replace: '{{:Sender.Zip}}'},
		{find: '\\[Sender.Country\\]', replace: '{{:Sender.Country}}'},
		{find: '\\[Sender.Phone\\]', replace: '{{:Sender.Phone}}'},
		{find: '\\[Sender.PhoneExtension\\]', replace: '{{:Sender.PhoneExtension}}'},
		{find: '\\[Sender.Fax\\]', replace: '{{:Sender.Fax}}'},
		{find: '\\[Sender.Cell\\]', replace: '{{:Sender.Cell}}'},
		{find: '\\[Sender.Email\\]', replace: '{{:Sender.Email}}'},
		{find: '\\[Sender.EmailLogoURL\\]', replace: '{{:Sender.EmailLogoURL}}'},
		{find: '\\[Sender.FullAddress\\]', replace: '{{:Sender.FullAddress}}'},
		{find: '\\[Sender.Email2\\]', replace: '{{:Sender.Email2}}'},
		{find: '\\[Sender.Signature\\]', replace: '{{:Sender.Signature}}'},
		{find: '\\[Sender.UserType\\]', replace: '{{:Sender.UserType}}'},
		{find: '\\[SenderPM.Signature\\]', replace: '{{:SenderPM.Signature}}'},
		{find: '\\[SenderPM.Username\\]', replace: '{{:SenderPM.Username}}'},
		{find: '\\[SenderPM.Company\\]', replace: '{{:SenderPM.Company}}'},
		{find: '\\[SenderPM.Contact\\]', replace: '{{:SenderPM.Contact}}'},
		{find: '\\[SenderPM.Address1\\]', replace: '{{:SenderPM.Address1}}'},
		{find: '\\[SenderPM.Address2\\]', replace: '{{:SenderPM.Address2}}'},
		{find: '\\[SenderPM.City\\]', replace: '{{:SenderPM.City}}'},
		{find: '\\[SenderPM.State\\]', replace: '{{:SenderPM.State}}'},
		{find: '\\[SenderPM.Zip\\]', replace: '{{:SenderPM.Zip}}'},
		{find: '\\[SenderPM.Country\\]', replace: '{{:SenderPM.Country}}'},
		{find: '\\[SenderPM.Phone\\]', replace: '{{:SenderPM.Phone}}'},
		{find: '\\[SenderPM.PhoneExtension\\]', replace: '{{:SenderPM.PhoneExtension}}'},
		{find: '\\[SenderPM.Fax\\]', replace: '{{:SenderPM.Fax}}'},
		{find: '\\[SenderPM.Cell\\]', replace: '{{:SenderPM.Cell}}'},
		{find: '\\[SenderPM.Email\\]', replace: '{{:SenderPM.Email}}'},
		{find: '\\[SenderPM.EmailLogoURL\\]', replace: '{{:SenderPM.EmailLogoURL}}'},
		{find: '\\[SenderPM.FullAddress\\]', replace: '{{:SenderPM.FullAddress}}'},
		{find: '\\[SenderPM.Email2\\]', replace: '{{:SenderPM.Email2}}'},
		{find: '\\[SenderPM.UserType\\]', replace: '{{:SenderPM.UserType}}'},
		{find: '\\[ProjectContact2.Username\\]', replace: '{{:ProjectContact2.Username}}'},
		{find: '\\[ProjectContact2.Company\\]', replace: '{{:ProjectContact2.Company}}'},
		{find: '\\[ProjectContact2.Contact\\]', replace: '{{:ProjectContact2.Contact}}'},
		{find: '\\[ProjectContact2.Address1\\]', replace: '{{:ProjectContact2.Address1}}'},
		{find: '\\[ProjectContact2.Address2\\]', replace: '{{:ProjectContact2.Address2}}'},
		{find: '\\[ProjectContact2.City\\]', replace: '{{:ProjectContact2.City}}'},
		{find: '\\[ProjectContact2.State\\]', replace: '{{:ProjectContact2.State}}'},
		{find: '\\[ProjectContact2.Zip\\]', replace: '{{:ProjectContact2.Zip}}'},
		{find: '\\[ProjectContact2.Country\\]', replace: '{{:ProjectContact2.Country}}'},
		{find: '\\[ProjectContact2.Phone\\]', replace: '{{:ProjectContact2.Phone}}'},
		{find: '\\[ProjectContact2.PhoneExtension\\]', replace: '{{:ProjectContact2.PhoneExtension}}'},
		{find: '\\[ProjectContact2.Fax\\]', replace: '{{:ProjectContact2.Fax}}'},
		{find: '\\[ProjectContact2.Cell\\]', replace: '{{:ProjectContact2.Cell}}'},
		{find: '\\[ProjectContact2.Email\\]', replace: '{{:ProjectContact2.Email}}'},
		{find: '\\[ProjectContact2.EmailLogoURL\\]', replace: '{{:ProjectContact2.EmailLogoURL}}'},
		{find: '\\[ProjectContact2.FullAddress\\]', replace: '{{:ProjectContact2.FullAddress}}'},
		{find: '\\[ProjectContact2.Email2\\]', replace: '{{:ProjectContact2.Email2}}'},
		{find: '\\[ProjectContact2.UserType\\]', replace: '{{:ProjectContact2.UserType}}'},
		{find: '\\[Recipient.Company\\]', replace: '{{:Recipient.Company}}'},
		{find: '\\[Recipient.Contact\\]', replace: '{{:Recipient.Contact}}'},
		{find: '\\[Recipient.FirstName\\]', replace: '{{:Recipient.FirstName}}'},
		{find: '\\[Recipient.Title\\]', replace: '{{:Recipient.Title}}'},
		{find: '\\[Recipient.Address1\\]', replace: '{{:Recipient.Address1}}'},
		{find: '\\[Recipient.Address2\\]', replace: '{{:Recipient.Address2}}'},
		{find: '\\[Recipient.City\\]', replace: '{{:Recipient.City}}'},
		{find: '\\[Recipient.State\\]', replace: '{{:Recipient.State}}'},
		{find: '\\[Recipient.Zip\\]', replace: '{{:Recipient.Zip}}'},
		{find: '\\[Recipient.Country\\]', replace: '{{:Recipient.Country}}'},
		{find: '\\[Recipient.Phone\\]', replace: '{{:Recipient.Phone}}'},
		{find: '\\[Recipient.PhoneExtension\\]', replace: '{{:Recipient.PhoneExtension}}'},
		{find: '\\[Recipient.Fax\\]', replace: '{{:Recipient.Fax}}'},
		{find: '\\[Recipient.Email\\]', replace: '{{:Recipient.Email}}'},
		{find: '\\[Recipient.EmailLogoURL\\]', replace: '{{:Recipient.EmailLogoURL}}'},
		{find: '\\[Recipient.FullAddress\\]', replace: '{{:Recipient.FullAddress}}'},
		{find: '\\[Portal.URL\\]', replace: '{{:Portal.URL}}'},
		{find: '\\[Portal.Domain\\]', replace: '{{:Portal.Domain}}'},
		{find: '\\[DateTime.Today\\]', replace: '{{:DateTime.Today}}'},
		{find: '\\[ProjectMessage.AccessKey\\]', replace: '{{:ProjectMessage.AccessKey}}'},
		{find: '\\[ProjectMessage.RSVPURL\\]', replace: '{{:ProjectMessage.RSVPURL}}'},
		{find: '\\[ProjectMessage.RecipientGroupList\\]', replace: '{{:ProjectMessage.RecipientGroupList}}'},
		{find: '\\[ProjectMessage.RecipientGroupListComma\\]', replace: '{{:ProjectMessage.RecipientGroupListComma}}'},
		{find: '\\[ProjectMessage.ResponseDueLabel\\]', replace: '{{:ProjectMessage.ResponseDueLabel}}'},
		{find: '\\[ProjectMessage.MessageResponseDueLabel\\]', replace: '{{:ProjectMessage.MessageResponseDueLabel}}'},
		{find: '\\[ProjectMessage.ResponseDueDate\\]', replace: '{{:ProjectMessage.ResponseDueDate}}'},
		{find: '\\[ProjectMessage.ResponseDueTime\\]', replace: '{{:ProjectMessage.ResponseDueTime}}'},
		{find: '\\[ProjectMessage.MessageSubject\\]', replace: '{{:ProjectMessage.MessageSubject}}'},
		{find: '\\[ProjectMessage.MessageBody\\]', replace: '{{:ProjectMessage.MessageBody}}'},
		{find: '\\[ProjectMessage.SentOnDate\\]', replace: '{{:ProjectMessage.SentOnDate}}'},
		{find: '\\[ProjectMessage.EstCompleteDate\\]', replace: '{{:ProjectMessage.EstCompleteDate}}'},
		{find: '\\[ProjectMessage.EstStartDate\\]', replace: '{{:ProjectMessage.EstStartDate}}'},
		{find: '\\[ProjectMessage.MessageType\\]', replace: '{{:ProjectMessage.MessageType}}'},
		{find: '\\[ProjectMessage.ResponseType\\]', replace: '{{:ProjectMessage.ResponseType}}'},
		{find: '\\[ProjectMessage.MessageName\\]', replace: '{{:ProjectMessage.MessageName}}'},
		{find: '\\[Project.ProjectId\\]', replace: '{{:Project.ProjectId}}'},
		{find: '\\[Project.Name\\]', replace: '{{:Project.Name}}'},
		{find: '\\[Project.Address1\\]', replace: '{{:Project.Address1}}'},
		{find: '\\[Project.Address2\\]', replace: '{{:Project.Address2}}'},
		{find: '\\[Project.City\\]', replace: '{{:Project.City}}'},
		{find: '\\[Project.State\\]', replace: '{{:Project.State}}'},
		{find: '\\[Project.Zip\\]', replace: '{{:Project.Zip}}'},
		{find: '\\[Project.Country\\]', replace: '{{:Project.Country}}'},
		{find: '\\[Project.Notes\\]', replace: '{{:Project.Notes}}'},
		{find: '\\[Project.ResponseDueLabel\\]', replace: '{{:Project.ResponseDueLabel}}'},
		{find: '\\[Project.MessageResponseDueLabel\\]', replace: '{{:Project.MessageResponseDueLabel}}'},
		{find: '\\[Project.ResponseDueDate\\]', replace: '{{:Project.ResponseDueDate}}'},
		{find: '\\[Project.ResponseDueTime\\]', replace: '{{:Project.ResponseDueTime}}'},
		{find: '\\[Project.ResponseDueShortTime\\]', replace: '{{:Project.ResponseDueShortTime}}'},
		{find: '\\[Project.ResponseDueTimeZone\\]', replace: '{{:Project.ResponseDueTimeZone}}'},
		{find: '\\[Project.ResponseDueDateWithBy\\]', replace: '{{:Project.ResponseDueDateWithBy}}'},
		{find: '\\[Project.StartDate\\]', replace: '{{:Project.StartDate}}'},
		{find: '\\[Project.EndDate\\]', replace: '{{:Project.EndDate}}'},
		{find: '\\[Project.ProjectStatus\\]', replace: '{{:Project.ProjectStatus}}'},
		{find: '\\[Project.CustomFieldLabel1\\]', replace: '{{:Project.CustomFieldLabel1}}'},
		{find: '\\[Project.CustomFieldValue1\\]', replace: '{{:Project.CustomFieldValue1}}'},
		{find: '\\[Project.CustomFieldValue1_CompanyName\\]', replace: '{{:Project.CustomFieldValue1_CompanyName}}'},
		{find: '\\[Project.CustomFieldValue1_ContactName\\]', replace: '{{:Project.CustomFieldValue1_ContactName}}'},
		{find: '\\[Project.CustomFieldValue1_ContactTitle\\]', replace: '{{:Project.CustomFieldValue1_ContactTitle}}'},
		{find: '\\[Project.CustomFieldValue1_Address1\\]', replace: '{{:Project.CustomFieldValue1_Address1}}'},
		{find: '\\[Project.CustomFieldValue1_Address2\\]', replace: '{{:Project.CustomFieldValue1_Address2}}'},
		{find: '\\[Project.CustomFieldValue1_City\\]', replace: '{{:Project.CustomFieldValue1_City}}'},
		{
			find: '\\[Project.CustomFieldValue1_StateProvince\\]',
			replace: '{{:Project.CustomFieldValue1_StateProvince}}'
		},
		{find: '\\[Project.CustomFieldValue1_PostalCode\\]', replace: '{{:Project.CustomFieldValue1_PostalCode}}'},
		{find: '\\[Project.CustomFieldValue1_Country\\]', replace: '{{:Project.CustomFieldValue1_Country}}'},
		{find: '\\[Project.CustomFieldValue1_Phone\\]', replace: '{{:Project.CustomFieldValue1_Phone}}'},
		{find: '\\[Project.CustomFieldValue1_Fax\\]', replace: '{{:Project.CustomFieldValue1_Fax}}'},
		{find: '\\[Project.CustomFieldValue1_Cell\\]', replace: '{{:Project.CustomFieldValue1_Cell}}'},
		{find: '\\[Project.CustomFieldValue1_Email\\]', replace: '{{:Project.CustomFieldValue1_Email}}'},
		{find: '\\[Project.CustomFieldLabel2\\]', replace: '{{:Project.CustomFieldLabel2}}'},
		{find: '\\[Project.CustomFieldValue2\\]', replace: '{{:Project.CustomFieldValue2}}'},
		{find: '\\[Project.CustomFieldValue2_CompanyName\\]', replace: '{{:Project.CustomFieldValue2_CompanyName}}'},
		{find: '\\[Project.CustomFieldValue2_ContactName\\]', replace: '{{:Project.CustomFieldValue2_ContactName}}'},
		{find: '\\[Project.CustomFieldValue2_ContactTitle\\]', replace: '{{:Project.CustomFieldValue2_ContactTitle}}'},
		{find: '\\[Project.CustomFieldValue2_Address1\\]', replace: '{{:Project.CustomFieldValue2_Address1}}'},
		{find: '\\[Project.CustomFieldValue2_Address2\\]', replace: '{{:Project.CustomFieldValue2_Address2}}'},
		{find: '\\[Project.CustomFieldValue2_City\\]', replace: '{{:Project.CustomFieldValue2_City}}'},
		{
			find: '\\[Project.CustomFieldValue2_StateProvince\\]',
			replace: '{{:Project.CustomFieldValue2_StateProvince}}'
		},
		{find: '\\[Project.CustomFieldValue2_PostalCode\\]', replace: '{{:Project.CustomFieldValue2_PostalCode}}'},
		{find: '\\[Project.CustomFieldValue2_Country\\]', replace: '{{:Project.CustomFieldValue2_Country}}'},
		{find: '\\[Project.CustomFieldValue2_Phone\\]', replace: '{{:Project.CustomFieldValue2_Phone}}'},
		{find: '\\[Project.CustomFieldValue2_Fax\\]', replace: '{{:Project.CustomFieldValue2_Fax}}'},
		{find: '\\[Project.CustomFieldValue2_Cell\\]', replace: '{{:Project.CustomFieldValue2_Cell}}'},
		{find: '\\[Project.CustomFieldValue2_Email\\]', replace: '{{:Project.CustomFieldValue2_Email}}'},
		{find: '\\[Project.CustomFieldLabel3\\]', replace: '{{:Project.CustomFieldLabel3}}'},
		{find: '\\[Project.CustomFieldValue3\\]', replace: '{{:Project.CustomFieldValue3}}'},
		{find: '\\[Project.CustomFieldValue3_CompanyName\\]', replace: '{{:Project.CustomFieldValue3_CompanyName}}'},
		{find: '\\[Project.CustomFieldValue3_ContactName\\]', replace: '{{:Project.CustomFieldValue3_ContactName}}'},
		{find: '\\[Project.CustomFieldValue3_ContactTitle\\]', replace: '{{:Project.CustomFieldValue3_ContactTitle}}'},
		{find: '\\[Project.CustomFieldValue3_Address1\\]', replace: '{{:Project.CustomFieldValue3_Address1}}'},
		{find: '\\[Project.CustomFieldValue3_Address2\\]', replace: '{{:Project.CustomFieldValue3_Address2}}'},
		{find: '\\[Project.CustomFieldValue3_City\\]', replace: '{{:Project.CustomFieldValue3_City}}'},
		{
			find: '\\[Project.CustomFieldValue3_StateProvince\\]',
			replace: '{{:Project.CustomFieldValue3_StateProvince}}'
		},
		{find: '\\[Project.CustomFieldValue3_PostalCode\\]', replace: '{{:Project.CustomFieldValue3_PostalCode}}'},
		{find: '\\[Project.CustomFieldValue3_Country\\]', replace: '{{:Project.CustomFieldValue3_Country}}'},
		{find: '\\[Project.CustomFieldValue3_Phone\\]', replace: '{{:Project.CustomFieldValue3_Phone}}'},
		{find: '\\[Project.CustomFieldValue3_Fax\\]', replace: '{{:Project.CustomFieldValue3_Fax}}'},
		{find: '\\[Project.CustomFieldValue3_Cell\\]', replace: '{{:Project.CustomFieldValue3_Cell}}'},
		{find: '\\[Project.CustomFieldValue3_Email\\]', replace: '{{:Project.CustomFieldValue3_Email}}'},
		{find: '\\[Project.CustomFieldLabel4\\]', replace: '{{:Project.CustomFieldLabel4}}'},
		{find: '\\[Project.CustomFieldValue4\\]', replace: '{{:Project.CustomFieldValue4}}'},
		{find: '\\[Project.CustomFieldValue4_CompanyName\\]', replace: '{{:Project.CustomFieldValue4_CompanyName}}'},
		{find: '\\[Project.CustomFieldValue4_ContactName\\]', replace: '{{:Project.CustomFieldValue4_ContactName}}'},
		{find: '\\[Project.CustomFieldValue4_ContactTitle\\]', replace: '{{:Project.CustomFieldValue4_ContactTitle}}'},
		{find: '\\[Project.CustomFieldValue4_Address1\\]', replace: '{{:Project.CustomFieldValue4_Address1}}'},
		{find: '\\[Project.CustomFieldValue4_Address2\\]', replace: '{{:Project.CustomFieldValue4_Address2}}'},
		{find: '\\[Project.CustomFieldValue4_City\\]', replace: '{{:Project.CustomFieldValue4_City}}'},
		{
			find: '\\[Project.CustomFieldValue4_StateProvince\\]',
			replace: '{{:Project.CustomFieldValue4_StateProvince}}'
		},
		{find: '\\[Project.CustomFieldValue4_PostalCode\\]', replace: '{{:Project.CustomFieldValue4_PostalCode}}'},
		{find: '\\[Project.CustomFieldValue4_Country\\]', replace: '{{:Project.CustomFieldValue4_Country}}'},
		{find: '\\[Project.CustomFieldValue4_Phone\\]', replace: '{{:Project.CustomFieldValue4_Phone}}'},
		{find: '\\[Project.CustomFieldValue4_Fax\\]', replace: '{{:Project.CustomFieldValue4_Fax}}'},
		{find: '\\[Project.CustomFieldValue4_Cell\\]', replace: '{{:Project.CustomFieldValue4_Cell}}'},
		{find: '\\[Project.CustomFieldValue4_Email\\]', replace: '{{:Project.CustomFieldValue4_Email}}'},
		{find: '\\[Project.CustomFieldLabel5\\]', replace: '{{:Project.CustomFieldLabel5}}'},
		{find: '\\[Project.CustomFieldValue5\\]', replace: '{{:Project.CustomFieldValue5}}'},
		{find: '\\[Project.CustomFieldValue5_CompanyName\\]', replace: '{{:Project.CustomFieldValue5_CompanyName}}'},
		{find: '\\[Project.CustomFieldValue5_ContactName\\]', replace: '{{:Project.CustomFieldValue5_ContactName}}'},
		{find: '\\[Project.CustomFieldValue5_ContactTitle\\]', replace: '{{:Project.CustomFieldValue5_ContactTitle}}'},
		{find: '\\[Project.CustomFieldValue5_Address1\\]', replace: '{{:Project.CustomFieldValue5_Address1}}'},
		{find: '\\[Project.CustomFieldValue5_Address2\\]', replace: '{{:Project.CustomFieldValue5_Address2}}'},
		{find: '\\[Project.CustomFieldValue5_City\\]', replace: '{{:Project.CustomFieldValue5_City}}'},
		{
			find: '\\[Project.CustomFieldValue5_StateProvince\\]',
			replace: '{{:Project.CustomFieldValue5_StateProvince}}'
		},
		{find: '\\[Project.CustomFieldValue5_PostalCode\\]', replace: '{{:Project.CustomFieldValue5_PostalCode}}'},
		{find: '\\[Project.CustomFieldValue5_Country\\]', replace: '{{:Project.CustomFieldValue5_Country}}'},
		{find: '\\[Project.CustomFieldValue5_Phone\\]', replace: '{{:Project.CustomFieldValue5_Phone}}'},
		{find: '\\[Project.CustomFieldValue5_Fax\\]', replace: '{{:Project.CustomFieldValue5_Fax}}'},
		{find: '\\[Project.CustomFieldValue5_Cell\\]', replace: '{{:Project.CustomFieldValue5_Cell}}'},
		{find: '\\[Project.CustomFieldValue5_Email\\]', replace: '{{:Project.CustomFieldValue5_Email}}'},
		{find: '\\[Project.CustomFieldLabel6\\]', replace: '{{:Project.CustomFieldLabel6}}'},
		{find: '\\[Project.CustomFieldValue6\\]', replace: '{{:Project.CustomFieldValue6}}'},
		{find: '\\[Project.CustomFieldValue6_CompanyName\\]', replace: '{{:Project.CustomFieldValue6_CompanyName}}'},
		{find: '\\[Project.CustomFieldValue6_ContactName\\]', replace: '{{:Project.CustomFieldValue6_ContactName}}'},
		{find: '\\[Project.CustomFieldValue6_ContactTitle\\]', replace: '{{:Project.CustomFieldValue6_ContactTitle}}'},
		{find: '\\[Project.CustomFieldValue6_Address1\\]', replace: '{{:Project.CustomFieldValue6_Address1}}'},
		{find: '\\[Project.CustomFieldValue6_Address2\\]', replace: '{{:Project.CustomFieldValue6_Address2}}'},
		{find: '\\[Project.CustomFieldValue6_City\\]', replace: '{{:Project.CustomFieldValue6_City}}'},
		{
			find: '\\[Project.CustomFieldValue6_StateProvince\\]',
			replace: '{{:Project.CustomFieldValue6_StateProvince}}'
		},
		{find: '\\[Project.CustomFieldValue6_PostalCode\\]', replace: '{{:Project.CustomFieldValue6_PostalCode}}'},
		{find: '\\[Project.CustomFieldValue6_Country\\]', replace: '{{:Project.CustomFieldValue6_Country}}'},
		{find: '\\[Project.CustomFieldValue6_Phone\\]', replace: '{{:Project.CustomFieldValue6_Phone}}'},
		{find: '\\[Project.CustomFieldValue6_Fax\\]', replace: '{{:Project.CustomFieldValue6_Fax}}'},
		{find: '\\[Project.CustomFieldValue6_Cell\\]', replace: '{{:Project.CustomFieldValue6_Cell}}'},
		{find: '\\[Project.CustomFieldValue6_Email\\]', replace: '{{:Project.CustomFieldValue6_Email}}'},
		{find: '\\[Project.CustomFieldLabel7\\]', replace: '{{:Project.CustomFieldLabel7}}'},
		{find: '\\[Project.CustomFieldValue7\\]', replace: '{{:Project.CustomFieldValue7}}'},
		{find: '\\[Project.CustomFieldValue7_CompanyName\\]', replace: '{{:Project.CustomFieldValue7_CompanyName}}'},
		{find: '\\[Project.CustomFieldValue7_ContactName\\]', replace: '{{:Project.CustomFieldValue7_ContactName}}'},
		{find: '\\[Project.CustomFieldValue7_ContactTitle\\]', replace: '{{:Project.CustomFieldValue7_ContactTitle}}'},
		{find: '\\[Project.CustomFieldValue7_Address1\\]', replace: '{{:Project.CustomFieldValue7_Address1}}'},
		{find: '\\[Project.CustomFieldValue7_Address2\\]', replace: '{{:Project.CustomFieldValue7_Address2}}'},
		{find: '\\[Project.CustomFieldValue7_City\\]', replace: '{{:Project.CustomFieldValue7_City}}'},
		{
			find: '\\[Project.CustomFieldValue7_StateProvince\\]',
			replace: '{{:Project.CustomFieldValue7_StateProvince}}'
		},
		{find: '\\[Project.CustomFieldValue7_PostalCode\\]', replace: '{{:Project.CustomFieldValue7_PostalCode}}'},
		{find: '\\[Project.CustomFieldValue7_Country\\]', replace: '{{:Project.CustomFieldValue7_Country}}'},
		{find: '\\[Project.CustomFieldValue7_Phone\\]', replace: '{{:Project.CustomFieldValue7_Phone}}'},
		{find: '\\[Project.CustomFieldValue7_Fax\\]', replace: '{{:Project.CustomFieldValue7_Fax}}'},
		{find: '\\[Project.CustomFieldValue7_Cell\\]', replace: '{{:Project.CustomFieldValue7_Cell}}'},
		{find: '\\[Project.CustomFieldValue7_Email\\]', replace: '{{:Project.CustomFieldValue7_Email}}'},
		{find: '\\[Project.CustomFieldLabel8\\]', replace: '{{:Project.CustomFieldLabel8}}'},
		{find: '\\[Project.CustomFieldValue8\\]', replace: '{{:Project.CustomFieldValue8}}'},
		{find: '\\[Project.CustomFieldValue8_CompanyName\\]', replace: '{{:Project.CustomFieldValue8_CompanyName}}'},
		{find: '\\[Project.CustomFieldValue8_ContactName\\]', replace: '{{:Project.CustomFieldValue8_ContactName}}'},
		{find: '\\[Project.CustomFieldValue8_ContactTitle\\]', replace: '{{:Project.CustomFieldValue8_ContactTitle}}'},
		{find: '\\[Project.CustomFieldValue8_Address1\\]', replace: '{{:Project.CustomFieldValue8_Address1}}'},
		{find: '\\[Project.CustomFieldValue8_Address2\\]', replace: '{{:Project.CustomFieldValue8_Address2}}'},
		{find: '\\[Project.CustomFieldValue8_City\\]', replace: '{{:Project.CustomFieldValue8_City}}'},
		{
			find: '\\[Project.CustomFieldValue8_StateProvince\\]',
			replace: '{{:Project.CustomFieldValue8_StateProvince}}'
		},
		{find: '\\[Project.CustomFieldValue8_PostalCode\\]', replace: '{{:Project.CustomFieldValue8_PostalCode}}'},
		{find: '\\[Project.CustomFieldValue8_Country\\]', replace: '{{:Project.CustomFieldValue8_Country}}'},
		{find: '\\[Project.CustomFieldValue8_Phone\\]', replace: '{{:Project.CustomFieldValue8_Phone}}'},
		{find: '\\[Project.CustomFieldValue8_Fax\\]', replace: '{{:Project.CustomFieldValue8_Fax}}'},
		{find: '\\[Project.CustomFieldValue8_Cell\\]', replace: '{{:Project.CustomFieldValue8_Cell}}'},
		{find: '\\[Project.CustomFieldValue8_Email\\]', replace: '{{:Project.CustomFieldValue8_Email}}'},
		{find: '\\[Project.CustomFieldLabel9\\]', replace: '{{:Project.CustomFieldLabel9}}'},
		{find: '\\[Project.CustomFieldValue9\\]', replace: '{{:Project.CustomFieldValue9}}'},
		{find: '\\[Project.CustomFieldValue9_CompanyName\\]', replace: '{{:Project.CustomFieldValue9_CompanyName}}'},
		{find: '\\[Project.CustomFieldValue9_ContactName\\]', replace: '{{:Project.CustomFieldValue9_ContactName}}'},
		{find: '\\[Project.CustomFieldValue9_ContactTitle\\]', replace: '{{:Project.CustomFieldValue9_ContactTitle}}'},
		{find: '\\[Project.CustomFieldValue9_Address1\\]', replace: '{{:Project.CustomFieldValue9_Address1}}'},
		{find: '\\[Project.CustomFieldValue9_Address2\\]', replace: '{{:Project.CustomFieldValue9_Address2}}'},
		{find: '\\[Project.CustomFieldValue9_City\\]', replace: '{{:Project.CustomFieldValue9_City}}'},
		{
			find: '\\[Project.CustomFieldValue9_StateProvince\\]',
			replace: '{{:Project.CustomFieldValue9_StateProvince}}'
		},
		{find: '\\[Project.CustomFieldValue9_PostalCode\\]', replace: '{{:Project.CustomFieldValue9_PostalCode}}'},
		{find: '\\[Project.CustomFieldValue9_Country\\]', replace: '{{:Project.CustomFieldValue9_Country}}'},
		{find: '\\[Project.CustomFieldValue9_Phone\\]', replace: '{{:Project.CustomFieldValue9_Phone}}'},
		{find: '\\[Project.CustomFieldValue9_Fax\\]', replace: '{{:Project.CustomFieldValue9_Fax}}'},
		{find: '\\[Project.CustomFieldValue9_Cell\\]', replace: '{{:Project.CustomFieldValue9_Cell}}'},
		{find: '\\[Project.CustomFieldValue9_Email\\]', replace: '{{:Project.CustomFieldValue9_Email}}'},
		{find: '\\[Project.CustomFieldLabel10\\]', replace: '{{:Project.CustomFieldLabel10}}'},
		{find: '\\[Project.CustomFieldValue10\\]', replace: '{{:Project.CustomFieldValue10}}'},
		{find: '\\[Project.CustomFieldValue10_CompanyName\\]', replace: '{{:Project.CustomFieldValue10_CompanyName}}'},
		{find: '\\[Project.CustomFieldValue10_ContactName\\]', replace: '{{:Project.CustomFieldValue10_ContactName}}'},
		{
			find: '\\[Project.CustomFieldValue10_ContactTitle\\]',
			replace: '{{:Project.CustomFieldValue10_ContactTitle}}'
		},
		{find: '\\[Project.CustomFieldValue10_Address1\\]', replace: '{{:Project.CustomFieldValue10_Address1}}'},
		{find: '\\[Project.CustomFieldValue10_Address2\\]', replace: '{{:Project.CustomFieldValue10_Address2}}'},
		{find: '\\[Project.CustomFieldValue10_City\\]', replace: '{{:Project.CustomFieldValue10_City}}'},
		{
			find: '\\[Project.CustomFieldValue10_StateProvince\\]',
			replace: '{{:Project.CustomFieldValue10_StateProvince}}'
		},
		{find: '\\[Project.CustomFieldValue10_PostalCode\\]', replace: '{{:Project.CustomFieldValue10_PostalCode}}'},
		{find: '\\[Project.CustomFieldValue10_Country\\]', replace: '{{:Project.CustomFieldValue10_Country}}'},
		{find: '\\[Project.CustomFieldValue10_Phone\\]', replace: '{{:Project.CustomFieldValue10_Phone}}'},
		{find: '\\[Project.CustomFieldValue10_Fax\\]', replace: '{{:Project.CustomFieldValue10_Fax}}'},
		{find: '\\[Project.CustomFieldValue10_Cell\\]', replace: '{{:Project.CustomFieldValue10_Cell}}'},
		{find: '\\[Project.CustomFieldValue10_Email\\]', replace: '{{:Project.CustomFieldValue10_Email}}'},
		{find: '\\[Project.CustomFieldLabel11\\]', replace: '{{:Project.CustomFieldLabel11}}'},
		{find: '\\[Project.CustomFieldValue11\\]', replace: '{{:Project.CustomFieldValue11}}'},
		{find: '\\[Project.CustomFieldValue11_CompanyName\\]', replace: '{{:Project.CustomFieldValue11_CompanyName}}'},
		{find: '\\[Project.CustomFieldValue11_ContactName\\]', replace: '{{:Project.CustomFieldValue11_ContactName}}'},
		{
			find: '\\[Project.CustomFieldValue11_ContactTitle\\]',
			replace: '{{:Project.CustomFieldValue11_ContactTitle}}'
		},
		{find: '\\[Project.CustomFieldValue11_Address1\\]', replace: '{{:Project.CustomFieldValue11_Address1}}'},
		{find: '\\[Project.CustomFieldValue11_Address2\\]', replace: '{{:Project.CustomFieldValue11_Address2}}'},
		{find: '\\[Project.CustomFieldValue11_City\\]', replace: '{{:Project.CustomFieldValue11_City}}'},
		{
			find: '\\[Project.CustomFieldValue11_StateProvince\\]',
			replace: '{{:Project.CustomFieldValue11_StateProvince}}'
		},
		{find: '\\[Project.CustomFieldValue11_PostalCode\\]', replace: '{{:Project.CustomFieldValue11_PostalCode}}'},
		{find: '\\[Project.CustomFieldValue11_Country\\]', replace: '{{:Project.CustomFieldValue11_Country}}'},
		{find: '\\[Project.CustomFieldValue11_Phone\\]', replace: '{{:Project.CustomFieldValue11_Phone}}'},
		{find: '\\[Project.CustomFieldValue11_Fax\\]', replace: '{{:Project.CustomFieldValue11_Fax}}'},
		{find: '\\[Project.CustomFieldValue11_Cell\\]', replace: '{{:Project.CustomFieldValue11_Cell}}'},
		{find: '\\[Project.CustomFieldValue11_Email\\]', replace: '{{:Project.CustomFieldValue11_Email}}'},
		{find: '\\[Project.CustomFieldLabel12\\]', replace: '{{:Project.CustomFieldLabel12}}'},
		{find: '\\[Project.CustomFieldValue12\\]', replace: '{{:Project.CustomFieldValue12}}'},
		{find: '\\[Project.CustomFieldValue12_CompanyName\\]', replace: '{{:Project.CustomFieldValue12_CompanyName}}'},
		{find: '\\[Project.CustomFieldValue12_ContactName\\]', replace: '{{:Project.CustomFieldValue12_ContactName}}'},
		{
			find: '\\[Project.CustomFieldValue12_ContactTitle\\]',
			replace: '{{:Project.CustomFieldValue12_ContactTitle}}'
		},
		{find: '\\[Project.CustomFieldValue12_Address1\\]', replace: '{{:Project.CustomFieldValue12_Address1}}'},
		{find: '\\[Project.CustomFieldValue12_Address2\\]', replace: '{{:Project.CustomFieldValue12_Address2}}'},
		{find: '\\[Project.CustomFieldValue12_City\\]', replace: '{{:Project.CustomFieldValue12_City}}'},
		{
			find: '\\[Project.CustomFieldValue12_StateProvince\\]',
			replace: '{{:Project.CustomFieldValue12_StateProvince}}'
		},
		{find: '\\[Project.CustomFieldValue12_PostalCode\\]', replace: '{{:Project.CustomFieldValue12_PostalCode}}'},
		{find: '\\[Project.CustomFieldValue12_Country\\]', replace: '{{:Project.CustomFieldValue12_Country}}'},
		{find: '\\[Project.CustomFieldValue12_Phone\\]', replace: '{{:Project.CustomFieldValue12_Phone}}'},
		{find: '\\[Project.CustomFieldValue12_Fax\\]', replace: '{{:Project.CustomFieldValue12_Fax}}'},
		{find: '\\[Project.CustomFieldValue12_Cell\\]', replace: '{{:Project.CustomFieldValue12_Cell}}'},
		{find: '\\[Project.CustomFieldValue12_Email\\]', replace: '{{:Project.CustomFieldValue12_Email}}'},
		{find: '\\[Project.CustomFieldLabel13\\]', replace: '{{:Project.CustomFieldLabel13}}'},
		{find: '\\[Project.CustomFieldValue13\\]', replace: '{{:Project.CustomFieldValue13}}'},
		{find: '\\[Project.CustomFieldValue13_CompanyName\\]', replace: '{{:Project.CustomFieldValue13_CompanyName}}'},
		{find: '\\[Project.CustomFieldValue13_ContactName\\]', replace: '{{:Project.CustomFieldValue13_ContactName}}'},
		{
			find: '\\[Project.CustomFieldValue13_ContactTitle\\]',
			replace: '{{:Project.CustomFieldValue13_ContactTitle}}'
		},
		{find: '\\[Project.CustomFieldValue13_Address1\\]', replace: '{{:Project.CustomFieldValue13_Address1}}'},
		{find: '\\[Project.CustomFieldValue13_Address2\\]', replace: '{{:Project.CustomFieldValue13_Address2}}'},
		{find: '\\[Project.CustomFieldValue13_City\\]', replace: '{{:Project.CustomFieldValue13_City}}'},
		{
			find: '\\[Project.CustomFieldValue13_StateProvince\\]',
			replace: '{{:Project.CustomFieldValue13_StateProvince}}'
		},
		{find: '\\[Project.CustomFieldValue13_PostalCode\\]', replace: '{{:Project.CustomFieldValue13_PostalCode}}'},
		{find: '\\[Project.CustomFieldValue13_Country\\]', replace: '{{:Project.CustomFieldValue13_Country}}'},
		{find: '\\[Project.CustomFieldValue13_Phone\\]', replace: '{{:Project.CustomFieldValue13_Phone}}'},
		{find: '\\[Project.CustomFieldValue13_Fax\\]', replace: '{{:Project.CustomFieldValue13_Fax}}'},
		{find: '\\[Project.CustomFieldValue13_Cell\\]', replace: '{{:Project.CustomFieldValue13_Cell}}'},
		{find: '\\[Project.CustomFieldValue13_Email\\]', replace: '{{:Project.CustomFieldValue13_Email}}'},
		{find: '\\[Project.CustomFieldLabel14\\]', replace: '{{:Project.CustomFieldLabel14}}'},
		{find: '\\[Project.CustomFieldValue14\\]', replace: '{{:Project.CustomFieldValue14}}'},
		{find: '\\[Project.CustomFieldValue14_CompanyName\\]', replace: '{{:Project.CustomFieldValue14_CompanyName}}'},
		{find: '\\[Project.CustomFieldValue14_ContactName\\]', replace: '{{:Project.CustomFieldValue14_ContactName}}'},
		{
			find: '\\[Project.CustomFieldValue14_ContactTitle\\]',
			replace: '{{:Project.CustomFieldValue14_ContactTitle}}'
		},
		{find: '\\[Project.CustomFieldValue14_Address1\\]', replace: '{{:Project.CustomFieldValue14_Address1}}'},
		{find: '\\[Project.CustomFieldValue14_Address2\\]', replace: '{{:Project.CustomFieldValue14_Address2}}'},
		{find: '\\[Project.CustomFieldValue14_City\\]', replace: '{{:Project.CustomFieldValue14_City}}'},
		{
			find: '\\[Project.CustomFieldValue14_StateProvince\\]',
			replace: '{{:Project.CustomFieldValue14_StateProvince}}'
		},
		{find: '\\[Project.CustomFieldValue14_PostalCode\\]', replace: '{{:Project.CustomFieldValue14_PostalCode}}'},
		{find: '\\[Project.CustomFieldValue14_Country\\]', replace: '{{:Project.CustomFieldValue14_Country}}'},
		{find: '\\[Project.CustomFieldValue14_Phone\\]', replace: '{{:Project.CustomFieldValue14_Phone}}'},
		{find: '\\[Project.CustomFieldValue14_Fax\\]', replace: '{{:Project.CustomFieldValue14_Fax}}'},
		{find: '\\[Project.CustomFieldValue14_Cell\\]', replace: '{{:Project.CustomFieldValue14_Cell}}'},
		{find: '\\[Project.CustomFieldValue14_Email\\]', replace: '{{:Project.CustomFieldValue14_Email}}'},
		{find: '\\[Project.CustomFieldLabel15\\]', replace: '{{:Project.CustomFieldLabel15}}'},
		{find: '\\[Project.CustomFieldValue15\\]', replace: '{{:Project.CustomFieldValue15}}'},
		{find: '\\[Project.CustomFieldValue15_CompanyName\\]', replace: '{{:Project.CustomFieldValue15_CompanyName}}'},
		{find: '\\[Project.CustomFieldValue15_ContactName\\]', replace: '{{:Project.CustomFieldValue15_ContactName}}'},
		{
			find: '\\[Project.CustomFieldValue15_ContactTitle\\]',
			replace: '{{:Project.CustomFieldValue15_ContactTitle}}'
		},
		{find: '\\[Project.CustomFieldValue15_Address1\\]', replace: '{{:Project.CustomFieldValue15_Address1}}'},
		{find: '\\[Project.CustomFieldValue15_Address2\\]', replace: '{{:Project.CustomFieldValue15_Address2}}'},
		{find: '\\[Project.CustomFieldValue15_City\\]', replace: '{{:Project.CustomFieldValue15_City}}'},
		{
			find: '\\[Project.CustomFieldValue15_StateProvince\\]',
			replace: '{{:Project.CustomFieldValue15_StateProvince}}'
		},
		{find: '\\[Project.CustomFieldValue15_PostalCode\\]', replace: '{{:Project.CustomFieldValue15_PostalCode}}'},
		{find: '\\[Project.CustomFieldValue15_Country\\]', replace: '{{:Project.CustomFieldValue15_Country}}'},
		{find: '\\[Project.CustomFieldValue15_Phone\\]', replace: '{{:Project.CustomFieldValue15_Phone}}'},
		{find: '\\[Project.CustomFieldValue15_Fax\\]', replace: '{{:Project.CustomFieldValue15_Fax}}'},
		{find: '\\[Project.CustomFieldValue15_Cell\\]', replace: '{{:Project.CustomFieldValue15_Cell}}'},
		{find: '\\[Project.CustomFieldValue15_Email\\]', replace: '{{:Project.CustomFieldValue15_Email}}'},
		{find: '\\[Project.CustomFieldLabel16\\]', replace: '{{:Project.CustomFieldLabel16}}'},
		{find: '\\[Project.CustomFieldValue16\\]', replace: '{{:Project.CustomFieldValue16}}'},
		{find: '\\[Project.CustomFieldValue16_CompanyName\\]', replace: '{{:Project.CustomFieldValue16_CompanyName}}'},
		{find: '\\[Project.CustomFieldValue16_ContactName\\]', replace: '{{:Project.CustomFieldValue16_ContactName}}'},
		{
			find: '\\[Project.CustomFieldValue16_ContactTitle\\]',
			replace: '{{:Project.CustomFieldValue16_ContactTitle}}'
		},
		{find: '\\[Project.CustomFieldValue16_Address1\\]', replace: '{{:Project.CustomFieldValue16_Address1}}'},
		{find: '\\[Project.CustomFieldValue16_Address2\\]', replace: '{{:Project.CustomFieldValue16_Address2}}'},
		{find: '\\[Project.CustomFieldValue16_City\\]', replace: '{{:Project.CustomFieldValue16_City}}'},
		{
			find: '\\[Project.CustomFieldValue16_StateProvince\\]',
			replace: '{{:Project.CustomFieldValue16_StateProvince}}'
		},
		{find: '\\[Project.CustomFieldValue16_PostalCode\\]', replace: '{{:Project.CustomFieldValue16_PostalCode}}'},
		{find: '\\[Project.CustomFieldValue16_Country\\]', replace: '{{:Project.CustomFieldValue16_Country}}'},
		{find: '\\[Project.CustomFieldValue16_Phone\\]', replace: '{{:Project.CustomFieldValue16_Phone}}'},
		{find: '\\[Project.CustomFieldValue16_Fax\\]', replace: '{{:Project.CustomFieldValue16_Fax}}'},
		{find: '\\[Project.CustomFieldValue16_Cell\\]', replace: '{{:Project.CustomFieldValue16_Cell}}'},
		{find: '\\[Project.CustomFieldValue16_Email\\]', replace: '{{:Project.CustomFieldValue16_Email}}'},
		{find: '\\[Project.CustomFieldLabel17\\]', replace: '{{:Project.CustomFieldLabel17}}'},
		{find: '\\[Project.CustomFieldValue17\\]', replace: '{{:Project.CustomFieldValue17}}'},
		{find: '\\[Project.CustomFieldValue17_CompanyName\\]', replace: '{{:Project.CustomFieldValue17_CompanyName}}'},
		{find: '\\[Project.CustomFieldValue17_ContactName\\]', replace: '{{:Project.CustomFieldValue17_ContactName}}'},
		{
			find: '\\[Project.CustomFieldValue17_ContactTitle\\]',
			replace: '{{:Project.CustomFieldValue17_ContactTitle}}'
		},
		{find: '\\[Project.CustomFieldValue17_Address1\\]', replace: '{{:Project.CustomFieldValue17_Address1}}'},
		{find: '\\[Project.CustomFieldValue17_Address2\\]', replace: '{{:Project.CustomFieldValue17_Address2}}'},
		{find: '\\[Project.CustomFieldValue17_City\\]', replace: '{{:Project.CustomFieldValue17_City}}'},
		{
			find: '\\[Project.CustomFieldValue17_StateProvince\\]',
			replace: '{{:Project.CustomFieldValue17_StateProvince}}'
		},
		{find: '\\[Project.CustomFieldValue17_PostalCode\\]', replace: '{{:Project.CustomFieldValue17_PostalCode}}'},
		{find: '\\[Project.CustomFieldValue17_Country\\]', replace: '{{:Project.CustomFieldValue17_Country}}'},
		{find: '\\[Project.CustomFieldValue17_Phone\\]', replace: '{{:Project.CustomFieldValue17_Phone}}'},
		{find: '\\[Project.CustomFieldValue17_Fax\\]', replace: '{{:Project.CustomFieldValue17_Fax}}'},
		{find: '\\[Project.CustomFieldValue17_Cell\\]', replace: '{{:Project.CustomFieldValue17_Cell}}'},
		{find: '\\[Project.CustomFieldValue17_Email\\]', replace: '{{:Project.CustomFieldValue17_Email}}'},
		{find: '\\[Project.CustomFieldLabel18\\]', replace: '{{:Project.CustomFieldLabel18}}'},
		{find: '\\[Project.CustomFieldValue18\\]', replace: '{{:Project.CustomFieldValue18}}'},
		{find: '\\[Project.CustomFieldValue18_CompanyName\\]', replace: '{{:Project.CustomFieldValue18_CompanyName}}'},
		{find: '\\[Project.CustomFieldValue18_ContactName\\]', replace: '{{:Project.CustomFieldValue18_ContactName}}'},
		{
			find: '\\[Project.CustomFieldValue18_ContactTitle\\]',
			replace: '{{:Project.CustomFieldValue18_ContactTitle}}'
		},
		{find: '\\[Project.CustomFieldValue18_Address1\\]', replace: '{{:Project.CustomFieldValue18_Address1}}'},
		{find: '\\[Project.CustomFieldValue18_Address2\\]', replace: '{{:Project.CustomFieldValue18_Address2}}'},
		{find: '\\[Project.CustomFieldValue18_City\\]', replace: '{{:Project.CustomFieldValue18_City}}'},
		{
			find: '\\[Project.CustomFieldValue18_StateProvince\\]',
			replace: '{{:Project.CustomFieldValue18_StateProvince}}'
		},
		{find: '\\[Project.CustomFieldValue18_PostalCode\\]', replace: '{{:Project.CustomFieldValue18_PostalCode}}'},
		{find: '\\[Project.CustomFieldValue18_Country\\]', replace: '{{:Project.CustomFieldValue18_Country}}'},
		{find: '\\[Project.CustomFieldValue18_Phone\\]', replace: '{{:Project.CustomFieldValue18_Phone}}'},
		{find: '\\[Project.CustomFieldValue18_Fax\\]', replace: '{{:Project.CustomFieldValue18_Fax}}'},
		{find: '\\[Project.CustomFieldValue18_Cell\\]', replace: '{{:Project.CustomFieldValue18_Cell}}'},
		{find: '\\[Project.CustomFieldValue18_Email\\]', replace: '{{:Project.CustomFieldValue18_Email}}'},
		{find: '\\[Project.CustomFieldLabel19\\]', replace: '{{:Project.CustomFieldLabel19}}'},
		{find: '\\[Project.CustomFieldValue19\\]', replace: '{{:Project.CustomFieldValue19}}'},
		{find: '\\[Project.CustomFieldValue19_CompanyName\\]', replace: '{{:Project.CustomFieldValue19_CompanyName}}'},
		{find: '\\[Project.CustomFieldValue19_ContactName\\]', replace: '{{:Project.CustomFieldValue19_ContactName}}'},
		{
			find: '\\[Project.CustomFieldValue19_ContactTitle\\]',
			replace: '{{:Project.CustomFieldValue19_ContactTitle}}'
		},
		{find: '\\[Project.CustomFieldValue19_Address1\\]', replace: '{{:Project.CustomFieldValue19_Address1}}'},
		{find: '\\[Project.CustomFieldValue19_Address2\\]', replace: '{{:Project.CustomFieldValue19_Address2}}'},
		{find: '\\[Project.CustomFieldValue19_City\\]', replace: '{{:Project.CustomFieldValue19_City}}'},
		{
			find: '\\[Project.CustomFieldValue19_StateProvince\\]',
			replace: '{{:Project.CustomFieldValue19_StateProvince}}'
		},
		{find: '\\[Project.CustomFieldValue19_PostalCode\\]', replace: '{{:Project.CustomFieldValue19_PostalCode}}'},
		{find: '\\[Project.CustomFieldValue19_Country\\]', replace: '{{:Project.CustomFieldValue19_Country}}'},
		{find: '\\[Project.CustomFieldValue19_Phone\\]', replace: '{{:Project.CustomFieldValue19_Phone}}'},
		{find: '\\[Project.CustomFieldValue19_Fax\\]', replace: '{{:Project.CustomFieldValue19_Fax}}'},
		{find: '\\[Project.CustomFieldValue19_Cell\\]', replace: '{{:Project.CustomFieldValue19_Cell}}'},
		{find: '\\[Project.CustomFieldValue19_Email\\]', replace: '{{:Project.CustomFieldValue19_Email}}'},
		{find: '\\[Project.CustomFieldLabel20\\]', replace: '{{:Project.CustomFieldLabel20}}'},
		{find: '\\[Project.CustomFieldValue20\\]', replace: '{{:Project.CustomFieldValue20}}'},
		{find: '\\[Project.CustomFieldValue20_CompanyName\\]', replace: '{{:Project.CustomFieldValue20_CompanyName}}'},
		{find: '\\[Project.CustomFieldValue20_ContactName\\]', replace: '{{:Project.CustomFieldValue20_ContactName}}'},
		{
			find: '\\[Project.CustomFieldValue20_ContactTitle\\]',
			replace: '{{:Project.CustomFieldValue20_ContactTitle}}'
		},
		{find: '\\[Project.CustomFieldValue20_Address1\\]', replace: '{{:Project.CustomFieldValue20_Address1}}'},
		{find: '\\[Project.CustomFieldValue20_Address2\\]', replace: '{{:Project.CustomFieldValue20_Address2}}'},
		{find: '\\[Project.CustomFieldValue20_City\\]', replace: '{{:Project.CustomFieldValue20_City}}'},
		{
			find: '\\[Project.CustomFieldValue20_StateProvince\\]',
			replace: '{{:Project.CustomFieldValue20_StateProvince}}'
		},
		{find: '\\[Project.CustomFieldValue20_PostalCode\\]', replace: '{{:Project.CustomFieldValue20_PostalCode}}'},
		{find: '\\[Project.CustomFieldValue20_Country\\]', replace: '{{:Project.CustomFieldValue20_Country}}'},
		{find: '\\[Project.CustomFieldValue20_Phone\\]', replace: '{{:Project.CustomFieldValue20_Phone}}'},
		{find: '\\[Project.CustomFieldValue20_Fax\\]', replace: '{{:Project.CustomFieldValue20_Fax}}'},
		{find: '\\[Project.CustomFieldValue20_Cell\\]', replace: '{{:Project.CustomFieldValue20_Cell}}'},
		{find: '\\[Project.CustomFieldValue20_Email\\]', replace: '{{:Project.CustomFieldValue20_Email}}'},
		{find: '\\[Project.CustomFieldLabel21\\]', replace: '{{:Project.CustomFieldLabel21}}'},
		{find: '\\[Project.CustomFieldValue21\\]', replace: '{{:Project.CustomFieldValue21}}'},
		{find: '\\[Project.CustomFieldValue21_CompanyName\\]', replace: '{{:Project.CustomFieldValue21_CompanyName}}'},
		{find: '\\[Project.CustomFieldValue21_ContactName\\]', replace: '{{:Project.CustomFieldValue21_ContactName}}'},
		{
			find: '\\[Project.CustomFieldValue21_ContactTitle\\]',
			replace: '{{:Project.CustomFieldValue21_ContactTitle}}'
		},
		{find: '\\[Project.CustomFieldValue21_Address1\\]', replace: '{{:Project.CustomFieldValue21_Address1}}'},
		{find: '\\[Project.CustomFieldValue21_Address2\\]', replace: '{{:Project.CustomFieldValue21_Address2}}'},
		{find: '\\[Project.CustomFieldValue21_City\\]', replace: '{{:Project.CustomFieldValue21_City}}'},
		{
			find: '\\[Project.CustomFieldValue21_StateProvince\\]',
			replace: '{{:Project.CustomFieldValue21_StateProvince}}'
		},
		{find: '\\[Project.CustomFieldValue21_PostalCode\\]', replace: '{{:Project.CustomFieldValue21_PostalCode}}'},
		{find: '\\[Project.CustomFieldValue21_Country\\]', replace: '{{:Project.CustomFieldValue21_Country}}'},
		{find: '\\[Project.CustomFieldValue21_Phone\\]', replace: '{{:Project.CustomFieldValue21_Phone}}'},
		{find: '\\[Project.CustomFieldValue21_Fax\\]', replace: '{{:Project.CustomFieldValue21_Fax}}'},
		{find: '\\[Project.CustomFieldValue21_Cell\\]', replace: '{{:Project.CustomFieldValue21_Cell}}'},
		{find: '\\[Project.CustomFieldValue21_Email\\]', replace: '{{:Project.CustomFieldValue21_Email}}'},
		{find: '\\[Project.CustomFieldLabel22\\]', replace: '{{:Project.CustomFieldLabel22}}'},
		{find: '\\[Project.CustomFieldValue22\\]', replace: '{{:Project.CustomFieldValue22}}'},
		{find: '\\[Project.CustomFieldValue22_CompanyName\\]', replace: '{{:Project.CustomFieldValue22_CompanyName}}'},
		{find: '\\[Project.CustomFieldValue22_ContactName\\]', replace: '{{:Project.CustomFieldValue22_ContactName}}'},
		{
			find: '\\[Project.CustomFieldValue22_ContactTitle\\]',
			replace: '{{:Project.CustomFieldValue22_ContactTitle}}'
		},
		{find: '\\[Project.CustomFieldValue22_Address1\\]', replace: '{{:Project.CustomFieldValue22_Address1}}'},
		{find: '\\[Project.CustomFieldValue22_Address2\\]', replace: '{{:Project.CustomFieldValue22_Address2}}'},
		{find: '\\[Project.CustomFieldValue22_City\\]', replace: '{{:Project.CustomFieldValue22_City}}'},
		{
			find: '\\[Project.CustomFieldValue22_StateProvince\\]',
			replace: '{{:Project.CustomFieldValue22_StateProvince}}'
		},
		{find: '\\[Project.CustomFieldValue22_PostalCode\\]', replace: '{{:Project.CustomFieldValue22_PostalCode}}'},
		{find: '\\[Project.CustomFieldValue22_Country\\]', replace: '{{:Project.CustomFieldValue22_Country}}'},
		{find: '\\[Project.CustomFieldValue22_Phone\\]', replace: '{{:Project.CustomFieldValue22_Phone}}'},
		{find: '\\[Project.CustomFieldValue22_Fax\\]', replace: '{{:Project.CustomFieldValue22_Fax}}'},
		{find: '\\[Project.CustomFieldValue22_Cell\\]', replace: '{{:Project.CustomFieldValue22_Cell}}'},
		{find: '\\[Project.CustomFieldValue22_Email\\]', replace: '{{:Project.CustomFieldValue22_Email}}'},
		{find: '\\[Project.CustomFieldLabel23\\]', replace: '{{:Project.CustomFieldLabel23}}'},
		{find: '\\[Project.CustomFieldValue23\\]', replace: '{{:Project.CustomFieldValue23}}'},
		{find: '\\[Project.CustomFieldValue23_CompanyName\\]', replace: '{{:Project.CustomFieldValue23_CompanyName}}'},
		{find: '\\[Project.CustomFieldValue23_ContactName\\]', replace: '{{:Project.CustomFieldValue23_ContactName}}'},
		{
			find: '\\[Project.CustomFieldValue23_ContactTitle\\]',
			replace: '{{:Project.CustomFieldValue23_ContactTitle}}'
		},
		{find: '\\[Project.CustomFieldValue23_Address1\\]', replace: '{{:Project.CustomFieldValue23_Address1}}'},
		{find: '\\[Project.CustomFieldValue23_Address2\\]', replace: '{{:Project.CustomFieldValue23_Address2}}'},
		{find: '\\[Project.CustomFieldValue23_City\\]', replace: '{{:Project.CustomFieldValue23_City}}'},
		{
			find: '\\[Project.CustomFieldValue23_StateProvince\\]',
			replace: '{{:Project.CustomFieldValue23_StateProvince}}'
		},
		{find: '\\[Project.CustomFieldValue23_PostalCode\\]', replace: '{{:Project.CustomFieldValue23_PostalCode}}'},
		{find: '\\[Project.CustomFieldValue23_Country\\]', replace: '{{:Project.CustomFieldValue23_Country}}'},
		{find: '\\[Project.CustomFieldValue23_Phone\\]', replace: '{{:Project.CustomFieldValue23_Phone}}'},
		{find: '\\[Project.CustomFieldValue23_Fax\\]', replace: '{{:Project.CustomFieldValue23_Fax}}'},
		{find: '\\[Project.CustomFieldValue23_Cell\\]', replace: '{{:Project.CustomFieldValue23_Cell}}'},
		{find: '\\[Project.CustomFieldValue23_Email\\]', replace: '{{:Project.CustomFieldValue23_Email}}'},
		{find: '\\[Project.CustomFieldLabel24\\]', replace: '{{:Project.CustomFieldLabel24}}'},
		{find: '\\[Project.CustomFieldValue24\\]', replace: '{{:Project.CustomFieldValue24}}'},
		{find: '\\[Project.CustomFieldValue24_CompanyName\\]', replace: '{{:Project.CustomFieldValue24_CompanyName}}'},
		{find: '\\[Project.CustomFieldValue24_ContactName\\]', replace: '{{:Project.CustomFieldValue24_ContactName}}'},
		{
			find: '\\[Project.CustomFieldValue24_ContactTitle\\]',
			replace: '{{:Project.CustomFieldValue24_ContactTitle}}'
		},
		{find: '\\[Project.CustomFieldValue24_Address1\\]', replace: '{{:Project.CustomFieldValue24_Address1}}'},
		{find: '\\[Project.CustomFieldValue24_Address2\\]', replace: '{{:Project.CustomFieldValue24_Address2}}'},
		{find: '\\[Project.CustomFieldValue24_City\\]', replace: '{{:Project.CustomFieldValue24_City}}'},
		{
			find: '\\[Project.CustomFieldValue24_StateProvince\\]',
			replace: '{{:Project.CustomFieldValue24_StateProvince}}'
		},
		{find: '\\[Project.CustomFieldValue24_PostalCode\\]', replace: '{{:Project.CustomFieldValue24_PostalCode}}'},
		{find: '\\[Project.CustomFieldValue24_Country\\]', replace: '{{:Project.CustomFieldValue24_Country}}'},
		{find: '\\[Project.CustomFieldValue24_Phone\\]', replace: '{{:Project.CustomFieldValue24_Phone}}'},
		{find: '\\[Project.CustomFieldValue24_Fax\\]', replace: '{{:Project.CustomFieldValue24_Fax}}'},
		{find: '\\[Project.CustomFieldValue24_Cell\\]', replace: '{{:Project.CustomFieldValue24_Cell}}'},
		{find: '\\[Project.CustomFieldValue24_Email\\]', replace: '{{:Project.CustomFieldValue24_Email}}'},
		{find: '\\[Project.CustomFieldLabel25\\]', replace: '{{:Project.CustomFieldLabel25}}'},
		{find: '\\[Project.CustomFieldValue25\\]', replace: '{{:Project.CustomFieldValue25}}'},
		{find: '\\[Project.CustomFieldValue25_CompanyName\\]', replace: '{{:Project.CustomFieldValue25_CompanyName}}'},
		{find: '\\[Project.CustomFieldValue25_ContactName\\]', replace: '{{:Project.CustomFieldValue25_ContactName}}'},
		{
			find: '\\[Project.CustomFieldValue25_ContactTitle\\]',
			replace: '{{:Project.CustomFieldValue25_ContactTitle}}'
		},
		{find: '\\[Project.CustomFieldValue25_Address1\\]', replace: '{{:Project.CustomFieldValue25_Address1}}'},
		{find: '\\[Project.CustomFieldValue25_Address2\\]', replace: '{{:Project.CustomFieldValue25_Address2}}'},
		{find: '\\[Project.CustomFieldValue25_City\\]', replace: '{{:Project.CustomFieldValue25_City}}'},
		{
			find: '\\[Project.CustomFieldValue25_StateProvince\\]',
			replace: '{{:Project.CustomFieldValue25_StateProvince}}'
		},
		{find: '\\[Project.CustomFieldValue25_PostalCode\\]', replace: '{{:Project.CustomFieldValue25_PostalCode}}'},
		{find: '\\[Project.CustomFieldValue25_Country\\]', replace: '{{:Project.CustomFieldValue25_Country}}'},
		{find: '\\[Project.CustomFieldValue25_Phone\\]', replace: '{{:Project.CustomFieldValue25_Phone}}'},
		{find: '\\[Project.CustomFieldValue25_Fax\\]', replace: '{{:Project.CustomFieldValue25_Fax}}'},
		{find: '\\[Project.CustomFieldValue25_Cell\\]', replace: '{{:Project.CustomFieldValue25_Cell}}'},
		{find: '\\[Project.CustomFieldValue25_Email\\]', replace: '{{:Project.CustomFieldValue25_Email}}'},
		{find: '\\[Project.CustomFieldLabel26\\]', replace: '{{:Project.CustomFieldLabel26}}'},
		{find: '\\[Project.CustomFieldValue26\\]', replace: '{{:Project.CustomFieldValue26}}'},
		{find: '\\[Project.CustomFieldValue26_CompanyName\\]', replace: '{{:Project.CustomFieldValue26_CompanyName}}'},
		{find: '\\[Project.CustomFieldValue26_ContactName\\]', replace: '{{:Project.CustomFieldValue26_ContactName}}'},
		{
			find: '\\[Project.CustomFieldValue26_ContactTitle\\]',
			replace: '{{:Project.CustomFieldValue26_ContactTitle}}'
		},
		{find: '\\[Project.CustomFieldValue26_Address1\\]', replace: '{{:Project.CustomFieldValue26_Address1}}'},
		{find: '\\[Project.CustomFieldValue26_Address2\\]', replace: '{{:Project.CustomFieldValue26_Address2}}'},
		{find: '\\[Project.CustomFieldValue26_City\\]', replace: '{{:Project.CustomFieldValue26_City}}'},
		{
			find: '\\[Project.CustomFieldValue26_StateProvince\\]',
			replace: '{{:Project.CustomFieldValue26_StateProvince}}'
		},
		{find: '\\[Project.CustomFieldValue26_PostalCode\\]', replace: '{{:Project.CustomFieldValue26_PostalCode}}'},
		{find: '\\[Project.CustomFieldValue26_Country\\]', replace: '{{:Project.CustomFieldValue26_Country}}'},
		{find: '\\[Project.CustomFieldValue26_Phone\\]', replace: '{{:Project.CustomFieldValue26_Phone}}'},
		{find: '\\[Project.CustomFieldValue26_Fax\\]', replace: '{{:Project.CustomFieldValue26_Fax}}'},
		{find: '\\[Project.CustomFieldValue26_Cell\\]', replace: '{{:Project.CustomFieldValue26_Cell}}'},
		{find: '\\[Project.CustomFieldValue26_Email\\]', replace: '{{:Project.CustomFieldValue26_Email}}'},
		{find: '\\[Project.CustomFieldLabel27\\]', replace: '{{:Project.CustomFieldLabel27}}'},
		{find: '\\[Project.CustomFieldValue27\\]', replace: '{{:Project.CustomFieldValue27}}'},
		{find: '\\[Project.CustomFieldValue27_CompanyName\\]', replace: '{{:Project.CustomFieldValue27_CompanyName}}'},
		{find: '\\[Project.CustomFieldValue27_ContactName\\]', replace: '{{:Project.CustomFieldValue27_ContactName}}'},
		{
			find: '\\[Project.CustomFieldValue27_ContactTitle\\]',
			replace: '{{:Project.CustomFieldValue27_ContactTitle}}'
		},
		{find: '\\[Project.CustomFieldValue27_Address1\\]', replace: '{{:Project.CustomFieldValue27_Address1}}'},
		{find: '\\[Project.CustomFieldValue27_Address2\\]', replace: '{{:Project.CustomFieldValue27_Address2}}'},
		{find: '\\[Project.CustomFieldValue27_City\\]', replace: '{{:Project.CustomFieldValue27_City}}'},
		{
			find: '\\[Project.CustomFieldValue27_StateProvince\\]',
			replace: '{{:Project.CustomFieldValue27_StateProvince}}'
		},
		{find: '\\[Project.CustomFieldValue27_PostalCode\\]', replace: '{{:Project.CustomFieldValue27_PostalCode}}'},
		{find: '\\[Project.CustomFieldValue27_Country\\]', replace: '{{:Project.CustomFieldValue27_Country}}'},
		{find: '\\[Project.CustomFieldValue27_Phone\\]', replace: '{{:Project.CustomFieldValue27_Phone}}'},
		{find: '\\[Project.CustomFieldValue27_Fax\\]', replace: '{{:Project.CustomFieldValue27_Fax}}'},
		{find: '\\[Project.CustomFieldValue27_Cell\\]', replace: '{{:Project.CustomFieldValue27_Cell}}'},
		{find: '\\[Project.CustomFieldValue27_Email\\]', replace: '{{:Project.CustomFieldValue27_Email}}'},
		{find: '\\[Project.CustomFieldLabel28\\]', replace: '{{:Project.CustomFieldLabel28}}'},
		{find: '\\[Project.CustomFieldValue28\\]', replace: '{{:Project.CustomFieldValue28}}'},
		{find: '\\[Project.CustomFieldValue28_CompanyName\\]', replace: '{{:Project.CustomFieldValue28_CompanyName}}'},
		{find: '\\[Project.CustomFieldValue28_ContactName\\]', replace: '{{:Project.CustomFieldValue28_ContactName}}'},
		{
			find: '\\[Project.CustomFieldValue28_ContactTitle\\]',
			replace: '{{:Project.CustomFieldValue28_ContactTitle}}'
		},
		{find: '\\[Project.CustomFieldValue28_Address1\\]', replace: '{{:Project.CustomFieldValue28_Address1}}'},
		{find: '\\[Project.CustomFieldValue28_Address2\\]', replace: '{{:Project.CustomFieldValue28_Address2}}'},
		{find: '\\[Project.CustomFieldValue28_City\\]', replace: '{{:Project.CustomFieldValue28_City}}'},
		{
			find: '\\[Project.CustomFieldValue28_StateProvince\\]',
			replace: '{{:Project.CustomFieldValue28_StateProvince}}'
		},
		{find: '\\[Project.CustomFieldValue28_PostalCode\\]', replace: '{{:Project.CustomFieldValue28_PostalCode}}'},
		{find: '\\[Project.CustomFieldValue28_Country\\]', replace: '{{:Project.CustomFieldValue28_Country}}'},
		{find: '\\[Project.CustomFieldValue28_Phone\\]', replace: '{{:Project.CustomFieldValue28_Phone}}'},
		{find: '\\[Project.CustomFieldValue28_Fax\\]', replace: '{{:Project.CustomFieldValue28_Fax}}'},
		{find: '\\[Project.CustomFieldValue28_Cell\\]', replace: '{{:Project.CustomFieldValue28_Cell}}'},
		{find: '\\[Project.CustomFieldValue28_Email\\]', replace: '{{:Project.CustomFieldValue28_Email}}'},
		{find: '\\[Project.CustomFieldLabel29\\]', replace: '{{:Project.CustomFieldLabel29}}'},
		{find: '\\[Project.CustomFieldValue29\\]', replace: '{{:Project.CustomFieldValue29}}'},
		{find: '\\[Project.CustomFieldValue29_CompanyName\\]', replace: '{{:Project.CustomFieldValue29_CompanyName}}'},
		{find: '\\[Project.CustomFieldValue29_ContactName\\]', replace: '{{:Project.CustomFieldValue29_ContactName}}'},
		{
			find: '\\[Project.CustomFieldValue29_ContactTitle\\]',
			replace: '{{:Project.CustomFieldValue29_ContactTitle}}'
		},
		{find: '\\[Project.CustomFieldValue29_Address1\\]', replace: '{{:Project.CustomFieldValue29_Address1}}'},
		{find: '\\[Project.CustomFieldValue29_Address2\\]', replace: '{{:Project.CustomFieldValue29_Address2}}'},
		{find: '\\[Project.CustomFieldValue29_City\\]', replace: '{{:Project.CustomFieldValue29_City}}'},
		{
			find: '\\[Project.CustomFieldValue29_StateProvince\\]',
			replace: '{{:Project.CustomFieldValue29_StateProvince}}'
		},
		{find: '\\[Project.CustomFieldValue29_PostalCode\\]', replace: '{{:Project.CustomFieldValue29_PostalCode}}'},
		{find: '\\[Project.CustomFieldValue29_Country\\]', replace: '{{:Project.CustomFieldValue29_Country}}'},
		{find: '\\[Project.CustomFieldValue29_Phone\\]', replace: '{{:Project.CustomFieldValue29_Phone}}'},
		{find: '\\[Project.CustomFieldValue29_Fax\\]', replace: '{{:Project.CustomFieldValue29_Fax}}'},
		{find: '\\[Project.CustomFieldValue29_Cell\\]', replace: '{{:Project.CustomFieldValue29_Cell}}'},
		{find: '\\[Project.CustomFieldValue29_Email\\]', replace: '{{:Project.CustomFieldValue29_Email}}'},
		{find: '\\[Project.CustomFieldLabel30\\]', replace: '{{:Project.CustomFieldLabel30}}'},
		{find: '\\[Project.CustomFieldValue30\\]', replace: '{{:Project.CustomFieldValue30}}'},
		{find: '\\[Project.CustomFieldValue30_CompanyName\\]', replace: '{{:Project.CustomFieldValue30_CompanyName}}'},
		{find: '\\[Project.CustomFieldValue30_ContactName\\]', replace: '{{:Project.CustomFieldValue30_ContactName}}'},
		{
			find: '\\[Project.CustomFieldValue30_ContactTitle\\]',
			replace: '{{:Project.CustomFieldValue30_ContactTitle}}'
		},
		{find: '\\[Project.CustomFieldValue30_Address1\\]', replace: '{{:Project.CustomFieldValue30_Address1}}'},
		{find: '\\[Project.CustomFieldValue30_Address2\\]', replace: '{{:Project.CustomFieldValue30_Address2}}'},
		{find: '\\[Project.CustomFieldValue30_City\\]', replace: '{{:Project.CustomFieldValue30_City}}'},
		{
			find: '\\[Project.CustomFieldValue30_StateProvince\\]',
			replace: '{{:Project.CustomFieldValue30_StateProvince}}'
		},
		{find: '\\[Project.CustomFieldValue30_PostalCode\\]', replace: '{{:Project.CustomFieldValue30_PostalCode}}'},
		{find: '\\[Project.CustomFieldValue30_Country\\]', replace: '{{:Project.CustomFieldValue30_Country}}'},
		{find: '\\[Project.CustomFieldValue30_Phone\\]', replace: '{{:Project.CustomFieldValue30_Phone}}'},
		{find: '\\[Project.CustomFieldValue30_Fax\\]', replace: '{{:Project.CustomFieldValue30_Fax}}'},
		{find: '\\[Project.CustomFieldValue30_Cell\\]', replace: '{{:Project.CustomFieldValue30_Cell}}'},
		{find: '\\[Project.CustomFieldValue30_Email\\]', replace: '{{:Project.CustomFieldValue30_Email}}'},
		{find: '\\[Project.CustomFieldLabel31\\]', replace: '{{:Project.CustomFieldLabel31}}'},
		{find: '\\[Project.CustomFieldValue31\\]', replace: '{{:Project.CustomFieldValue31}}'},
		{find: '\\[Project.CustomFieldValue31_CompanyName\\]', replace: '{{:Project.CustomFieldValue31_CompanyName}}'},
		{find: '\\[Project.CustomFieldValue31_ContactName\\]', replace: '{{:Project.CustomFieldValue31_ContactName}}'},
		{
			find: '\\[Project.CustomFieldValue31_ContactTitle\\]',
			replace: '{{:Project.CustomFieldValue31_ContactTitle}}'
		},
		{find: '\\[Project.CustomFieldValue31_Address1\\]', replace: '{{:Project.CustomFieldValue31_Address1}}'},
		{find: '\\[Project.CustomFieldValue31_Address2\\]', replace: '{{:Project.CustomFieldValue31_Address2}}'},
		{find: '\\[Project.CustomFieldValue31_City\\]', replace: '{{:Project.CustomFieldValue31_City}}'},
		{
			find: '\\[Project.CustomFieldValue31_StateProvince\\]',
			replace: '{{:Project.CustomFieldValue31_StateProvince}}'
		},
		{find: '\\[Project.CustomFieldValue31_PostalCode\\]', replace: '{{:Project.CustomFieldValue31_PostalCode}}'},
		{find: '\\[Project.CustomFieldValue31_Country\\]', replace: '{{:Project.CustomFieldValue31_Country}}'},
		{find: '\\[Project.CustomFieldValue31_Phone\\]', replace: '{{:Project.CustomFieldValue31_Phone}}'},
		{find: '\\[Project.CustomFieldValue31_Fax\\]', replace: '{{:Project.CustomFieldValue31_Fax}}'},
		{find: '\\[Project.CustomFieldValue31_Cell\\]', replace: '{{:Project.CustomFieldValue31_Cell}}'},
		{find: '\\[Project.CustomFieldValue31_Email\\]', replace: '{{:Project.CustomFieldValue31_Email}}'},
		{find: '\\[Project.CustomFieldLabel32\\]', replace: '{{:Project.CustomFieldLabel32}}'},
		{find: '\\[Project.CustomFieldValue32\\]', replace: '{{:Project.CustomFieldValue32}}'},
		{find: '\\[Project.CustomFieldValue32_CompanyName\\]', replace: '{{:Project.CustomFieldValue32_CompanyName}}'},
		{find: '\\[Project.CustomFieldValue32_ContactName\\]', replace: '{{:Project.CustomFieldValue32_ContactName}}'},
		{
			find: '\\[Project.CustomFieldValue32_ContactTitle\\]',
			replace: '{{:Project.CustomFieldValue32_ContactTitle}}'
		},
		{find: '\\[Project.CustomFieldValue32_Address1\\]', replace: '{{:Project.CustomFieldValue32_Address1}}'},
		{find: '\\[Project.CustomFieldValue32_Address2\\]', replace: '{{:Project.CustomFieldValue32_Address2}}'},
		{find: '\\[Project.CustomFieldValue32_City\\]', replace: '{{:Project.CustomFieldValue32_City}}'},
		{
			find: '\\[Project.CustomFieldValue32_StateProvince\\]',
			replace: '{{:Project.CustomFieldValue32_StateProvince}}'
		},
		{find: '\\[Project.CustomFieldValue32_PostalCode\\]', replace: '{{:Project.CustomFieldValue32_PostalCode}}'},
		{find: '\\[Project.CustomFieldValue32_Country\\]', replace: '{{:Project.CustomFieldValue32_Country}}'},
		{find: '\\[Project.CustomFieldValue32_Phone\\]', replace: '{{:Project.CustomFieldValue32_Phone}}'},
		{find: '\\[Project.CustomFieldValue32_Fax\\]', replace: '{{:Project.CustomFieldValue32_Fax}}'},
		{find: '\\[Project.CustomFieldValue32_Cell\\]', replace: '{{:Project.CustomFieldValue32_Cell}}'},
		{find: '\\[Project.CustomFieldValue32_Email\\]', replace: '{{:Project.CustomFieldValue32_Email}}'},
		{find: '\\[Project.CustomFieldLabel33\\]', replace: '{{:Project.CustomFieldLabel33}}'},
		{find: '\\[Project.CustomFieldValue33\\]', replace: '{{:Project.CustomFieldValue33}}'},
		{find: '\\[Project.CustomFieldValue33_CompanyName\\]', replace: '{{:Project.CustomFieldValue33_CompanyName}}'},
		{find: '\\[Project.CustomFieldValue33_ContactName\\]', replace: '{{:Project.CustomFieldValue33_ContactName}}'},
		{
			find: '\\[Project.CustomFieldValue33_ContactTitle\\]',
			replace: '{{:Project.CustomFieldValue33_ContactTitle}}'
		},
		{find: '\\[Project.CustomFieldValue33_Address1\\]', replace: '{{:Project.CustomFieldValue33_Address1}}'},
		{find: '\\[Project.CustomFieldValue33_Address2\\]', replace: '{{:Project.CustomFieldValue33_Address2}}'},
		{find: '\\[Project.CustomFieldValue33_City\\]', replace: '{{:Project.CustomFieldValue33_City}}'},
		{
			find: '\\[Project.CustomFieldValue33_StateProvince\\]',
			replace: '{{:Project.CustomFieldValue33_StateProvince}}'
		},
		{find: '\\[Project.CustomFieldValue33_PostalCode\\]', replace: '{{:Project.CustomFieldValue33_PostalCode}}'},
		{find: '\\[Project.CustomFieldValue33_Country\\]', replace: '{{:Project.CustomFieldValue33_Country}}'},
		{find: '\\[Project.CustomFieldValue33_Phone\\]', replace: '{{:Project.CustomFieldValue33_Phone}}'},
		{find: '\\[Project.CustomFieldValue33_Fax\\]', replace: '{{:Project.CustomFieldValue33_Fax}}'},
		{find: '\\[Project.CustomFieldValue33_Cell\\]', replace: '{{:Project.CustomFieldValue33_Cell}}'},
		{find: '\\[Project.CustomFieldValue33_Email\\]', replace: '{{:Project.CustomFieldValue33_Email}}'},
		{find: '\\[Project.CustomFieldLabel34\\]', replace: '{{:Project.CustomFieldLabel34}}'},
		{find: '\\[Project.CustomFieldValue34\\]', replace: '{{:Project.CustomFieldValue34}}'},
		{find: '\\[Project.CustomFieldValue34_CompanyName\\]', replace: '{{:Project.CustomFieldValue34_CompanyName}}'},
		{find: '\\[Project.CustomFieldValue34_ContactName\\]', replace: '{{:Project.CustomFieldValue34_ContactName}}'},
		{
			find: '\\[Project.CustomFieldValue34_ContactTitle\\]',
			replace: '{{:Project.CustomFieldValue34_ContactTitle}}'
		},
		{find: '\\[Project.CustomFieldValue34_Address1\\]', replace: '{{:Project.CustomFieldValue34_Address1}}'},
		{find: '\\[Project.CustomFieldValue34_Address2\\]', replace: '{{:Project.CustomFieldValue34_Address2}}'},
		{find: '\\[Project.CustomFieldValue34_City\\]', replace: '{{:Project.CustomFieldValue34_City}}'},
		{
			find: '\\[Project.CustomFieldValue34_StateProvince\\]',
			replace: '{{:Project.CustomFieldValue34_StateProvince}}'
		},
		{find: '\\[Project.CustomFieldValue34_PostalCode\\]', replace: '{{:Project.CustomFieldValue34_PostalCode}}'},
		{find: '\\[Project.CustomFieldValue34_Country\\]', replace: '{{:Project.CustomFieldValue34_Country}}'},
		{find: '\\[Project.CustomFieldValue34_Phone\\]', replace: '{{:Project.CustomFieldValue34_Phone}}'},
		{find: '\\[Project.CustomFieldValue34_Fax\\]', replace: '{{:Project.CustomFieldValue34_Fax}}'},
		{find: '\\[Project.CustomFieldValue34_Cell\\]', replace: '{{:Project.CustomFieldValue34_Cell}}'},
		{find: '\\[Project.CustomFieldValue34_Email\\]', replace: '{{:Project.CustomFieldValue34_Email}}'},
		{find: '\\[Project.CustomFieldLabel35\\]', replace: '{{:Project.CustomFieldLabel35}}'},
		{find: '\\[Project.CustomFieldValue35\\]', replace: '{{:Project.CustomFieldValue35}}'},
		{find: '\\[Project.CustomFieldValue35_CompanyName\\]', replace: '{{:Project.CustomFieldValue35_CompanyName}}'},
		{find: '\\[Project.CustomFieldValue35_ContactName\\]', replace: '{{:Project.CustomFieldValue35_ContactName}}'},
		{
			find: '\\[Project.CustomFieldValue35_ContactTitle\\]',
			replace: '{{:Project.CustomFieldValue35_ContactTitle}}'
		},
		{find: '\\[Project.CustomFieldValue35_Address1\\]', replace: '{{:Project.CustomFieldValue35_Address1}}'},
		{find: '\\[Project.CustomFieldValue35_Address2\\]', replace: '{{:Project.CustomFieldValue35_Address2}}'},
		{find: '\\[Project.CustomFieldValue35_City\\]', replace: '{{:Project.CustomFieldValue35_City}}'},
		{
			find: '\\[Project.CustomFieldValue35_StateProvince\\]',
			replace: '{{:Project.CustomFieldValue35_StateProvince}}'
		},
		{find: '\\[Project.CustomFieldValue35_PostalCode\\]', replace: '{{:Project.CustomFieldValue35_PostalCode}}'},
		{find: '\\[Project.CustomFieldValue35_Country\\]', replace: '{{:Project.CustomFieldValue35_Country}}'},
		{find: '\\[Project.CustomFieldValue35_Phone\\]', replace: '{{:Project.CustomFieldValue35_Phone}}'},
		{find: '\\[Project.CustomFieldValue35_Fax\\]', replace: '{{:Project.CustomFieldValue35_Fax}}'},
		{find: '\\[Project.CustomFieldValue35_Cell\\]', replace: '{{:Project.CustomFieldValue35_Cell}}'},
		{find: '\\[Project.CustomFieldValue35_Email\\]', replace: '{{:Project.CustomFieldValue35_Email}}'},
		{find: '\\[Project.CustomFieldLabel36\\]', replace: '{{:Project.CustomFieldLabel36}}'},
		{find: '\\[Project.CustomFieldValue36\\]', replace: '{{:Project.CustomFieldValue36}}'},
		{find: '\\[Project.CustomFieldValue36_CompanyName\\]', replace: '{{:Project.CustomFieldValue36_CompanyName}}'},
		{find: '\\[Project.CustomFieldValue36_ContactName\\]', replace: '{{:Project.CustomFieldValue36_ContactName}}'},
		{
			find: '\\[Project.CustomFieldValue36_ContactTitle\\]',
			replace: '{{:Project.CustomFieldValue36_ContactTitle}}'
		},
		{find: '\\[Project.CustomFieldValue36_Address1\\]', replace: '{{:Project.CustomFieldValue36_Address1}}'},
		{find: '\\[Project.CustomFieldValue36_Address2\\]', replace: '{{:Project.CustomFieldValue36_Address2}}'},
		{find: '\\[Project.CustomFieldValue36_City\\]', replace: '{{:Project.CustomFieldValue36_City}}'},
		{
			find: '\\[Project.CustomFieldValue36_StateProvince\\]',
			replace: '{{:Project.CustomFieldValue36_StateProvince}}'
		},
		{find: '\\[Project.CustomFieldValue36_PostalCode\\]', replace: '{{:Project.CustomFieldValue36_PostalCode}}'},
		{find: '\\[Project.CustomFieldValue36_Country\\]', replace: '{{:Project.CustomFieldValue36_Country}}'},
		{find: '\\[Project.CustomFieldValue36_Phone\\]', replace: '{{:Project.CustomFieldValue36_Phone}}'},
		{find: '\\[Project.CustomFieldValue36_Fax\\]', replace: '{{:Project.CustomFieldValue36_Fax}}'},
		{find: '\\[Project.CustomFieldValue36_Cell\\]', replace: '{{:Project.CustomFieldValue36_Cell}}'},
		{find: '\\[Project.CustomFieldValue36_Email\\]', replace: '{{:Project.CustomFieldValue36_Email}}'},
		{find: '\\[Project.CustomFieldLabel37\\]', replace: '{{:Project.CustomFieldLabel37}}'},
		{find: '\\[Project.CustomFieldValue37\\]', replace: '{{:Project.CustomFieldValue37}}'},
		{find: '\\[Project.CustomFieldValue37_CompanyName\\]', replace: '{{:Project.CustomFieldValue37_CompanyName}}'},
		{find: '\\[Project.CustomFieldValue37_ContactName\\]', replace: '{{:Project.CustomFieldValue37_ContactName}}'},
		{
			find: '\\[Project.CustomFieldValue37_ContactTitle\\]',
			replace: '{{:Project.CustomFieldValue37_ContactTitle}}'
		},
		{find: '\\[Project.CustomFieldValue37_Address1\\]', replace: '{{:Project.CustomFieldValue37_Address1}}'},
		{find: '\\[Project.CustomFieldValue37_Address2\\]', replace: '{{:Project.CustomFieldValue37_Address2}}'},
		{find: '\\[Project.CustomFieldValue37_City\\]', replace: '{{:Project.CustomFieldValue37_City}}'},
		{
			find: '\\[Project.CustomFieldValue37_StateProvince\\]',
			replace: '{{:Project.CustomFieldValue37_StateProvince}}'
		},
		{find: '\\[Project.CustomFieldValue37_PostalCode\\]', replace: '{{:Project.CustomFieldValue37_PostalCode}}'},
		{find: '\\[Project.CustomFieldValue37_Country\\]', replace: '{{:Project.CustomFieldValue37_Country}}'},
		{find: '\\[Project.CustomFieldValue37_Phone\\]', replace: '{{:Project.CustomFieldValue37_Phone}}'},
		{find: '\\[Project.CustomFieldValue37_Fax\\]', replace: '{{:Project.CustomFieldValue37_Fax}}'},
		{find: '\\[Project.CustomFieldValue37_Cell\\]', replace: '{{:Project.CustomFieldValue37_Cell}}'},
		{find: '\\[Project.CustomFieldValue37_Email\\]', replace: '{{:Project.CustomFieldValue37_Email}}'},
		{find: '\\[Project.CustomFieldLabel38\\]', replace: '{{:Project.CustomFieldLabel38}}'},
		{find: '\\[Project.CustomFieldValue38\\]', replace: '{{:Project.CustomFieldValue38}}'},
		{find: '\\[Project.CustomFieldValue38_CompanyName\\]', replace: '{{:Project.CustomFieldValue38_CompanyName}}'},
		{find: '\\[Project.CustomFieldValue38_ContactName\\]', replace: '{{:Project.CustomFieldValue38_ContactName}}'},
		{
			find: '\\[Project.CustomFieldValue38_ContactTitle\\]',
			replace: '{{:Project.CustomFieldValue38_ContactTitle}}'
		},
		{find: '\\[Project.CustomFieldValue38_Address1\\]', replace: '{{:Project.CustomFieldValue38_Address1}}'},
		{find: '\\[Project.CustomFieldValue38_Address2\\]', replace: '{{:Project.CustomFieldValue38_Address2}}'},
		{find: '\\[Project.CustomFieldValue38_City\\]', replace: '{{:Project.CustomFieldValue38_City}}'},
		{
			find: '\\[Project.CustomFieldValue38_StateProvince\\]',
			replace: '{{:Project.CustomFieldValue38_StateProvince}}'
		},
		{find: '\\[Project.CustomFieldValue38_PostalCode\\]', replace: '{{:Project.CustomFieldValue38_PostalCode}}'},
		{find: '\\[Project.CustomFieldValue38_Country\\]', replace: '{{:Project.CustomFieldValue38_Country}}'},
		{find: '\\[Project.CustomFieldValue38_Phone\\]', replace: '{{:Project.CustomFieldValue38_Phone}}'},
		{find: '\\[Project.CustomFieldValue38_Fax\\]', replace: '{{:Project.CustomFieldValue38_Fax}}'},
		{find: '\\[Project.CustomFieldValue38_Cell\\]', replace: '{{:Project.CustomFieldValue38_Cell}}'},
		{find: '\\[Project.CustomFieldValue38_Email\\]', replace: '{{:Project.CustomFieldValue38_Email}}'},
		{find: '\\[Project.CustomFieldLabel39\\]', replace: '{{:Project.CustomFieldLabel39}}'},
		{find: '\\[Project.CustomFieldValue39\\]', replace: '{{:Project.CustomFieldValue39}}'},
		{find: '\\[Project.CustomFieldValue39_CompanyName\\]', replace: '{{:Project.CustomFieldValue39_CompanyName}}'},
		{find: '\\[Project.CustomFieldValue39_ContactName\\]', replace: '{{:Project.CustomFieldValue39_ContactName}}'},
		{
			find: '\\[Project.CustomFieldValue39_ContactTitle\\]',
			replace: '{{:Project.CustomFieldValue39_ContactTitle}}'
		},
		{find: '\\[Project.CustomFieldValue39_Address1\\]', replace: '{{:Project.CustomFieldValue39_Address1}}'},
		{find: '\\[Project.CustomFieldValue39_Address2\\]', replace: '{{:Project.CustomFieldValue39_Address2}}'},
		{find: '\\[Project.CustomFieldValue39_City\\]', replace: '{{:Project.CustomFieldValue39_City}}'},
		{
			find: '\\[Project.CustomFieldValue39_StateProvince\\]',
			replace: '{{:Project.CustomFieldValue39_StateProvince}}'
		},
		{find: '\\[Project.CustomFieldValue39_PostalCode\\]', replace: '{{:Project.CustomFieldValue39_PostalCode}}'},
		{find: '\\[Project.CustomFieldValue39_Country\\]', replace: '{{:Project.CustomFieldValue39_Country}}'},
		{find: '\\[Project.CustomFieldValue39_Phone\\]', replace: '{{:Project.CustomFieldValue39_Phone}}'},
		{find: '\\[Project.CustomFieldValue39_Fax\\]', replace: '{{:Project.CustomFieldValue39_Fax}}'},
		{find: '\\[Project.CustomFieldValue39_Cell\\]', replace: '{{:Project.CustomFieldValue39_Cell}}'},
		{find: '\\[Project.CustomFieldValue39_Email\\]', replace: '{{:Project.CustomFieldValue39_Email}}'},
		{find: '\\[Project.CustomFieldValue1_CLBR\\]', replace: '{{:Project.CustomFieldValue1_CLBR}}'},
		{find: '\\[Project.CustomFieldValue2_CLBR\\]', replace: '{{:Project.CustomFieldValue2_CLBR}}'},
		{find: '\\[Project.CustomFieldValue3_CLBR\\]', replace: '{{:Project.CustomFieldValue3_CLBR}}'},
		{find: '\\[Project.CustomFieldValue4_CLBR\\]', replace: '{{:Project.CustomFieldValue4_CLBR}}'},
		{find: '\\[Project.CustomFieldValue5_CLBR\\]', replace: '{{:Project.CustomFieldValue5_CLBR}}'},
		{find: '\\[Project.CustomFieldValue6_CLBR\\]', replace: '{{:Project.CustomFieldValue6_CLBR}}'},
		{find: '\\[Project.CustomFieldValue7_CLBR\\]', replace: '{{:Project.CustomFieldValue7_CLBR}}'},
		{find: '\\[Project.CustomFieldValue8_CLBR\\]', replace: '{{:Project.CustomFieldValue8_CLBR}}'},
		{find: '\\[Project.CustomFieldValue9_CLBR\\]', replace: '{{:Project.CustomFieldValue9_CLBR}}'},
		{find: '\\[Project.CustomFieldValue10_CLBR\\]', replace: '{{:Project.CustomFieldValue10_CLBR}}'},
		{find: '\\[Project.CustomFieldValue11_CLBR\\]', replace: '{{:Project.CustomFieldValue11_CLBR}}'},
		{find: '\\[Project.CustomFieldValue12_CLBR\\]', replace: '{{:Project.CustomFieldValue12_CLBR}}'},
		{find: '\\[Project.CustomFieldValue13_CLBR\\]', replace: '{{:Project.CustomFieldValue13_CLBR}}'},
		{find: '\\[Project.CustomFieldValue14_CLBR\\]', replace: '{{:Project.CustomFieldValue14_CLBR}}'},
		{find: '\\[Project.CustomFieldValue15_CLBR\\]', replace: '{{:Project.CustomFieldValue15_CLBR}}'},
		{find: '\\[Project.CustomFieldValue16_CLBR\\]', replace: '{{:Project.CustomFieldValue16_CLBR}}'},
		{find: '\\[Project.CustomFieldValue17_CLBR\\]', replace: '{{:Project.CustomFieldValue17_CLBR}}'},
		{find: '\\[Project.CustomFieldValue18_CLBR\\]', replace: '{{:Project.CustomFieldValue18_CLBR}}'},
		{find: '\\[Project.CustomFieldValue19_CLBR\\]', replace: '{{:Project.CustomFieldValue19_CLBR}}'},
		{find: '\\[Project.CustomFieldValue20_CLBR\\]', replace: '{{:Project.CustomFieldValue20_CLBR}}'},
		{find: '\\[Project.CustomFieldValue21_CLBR\\]', replace: '{{:Project.CustomFieldValue21_CLBR}}'},
		{find: '\\[Project.CustomFieldValue22_CLBR\\]', replace: '{{:Project.CustomFieldValue22_CLBR}}'},
		{find: '\\[Project.CustomFieldValue23_CLBR\\]', replace: '{{:Project.CustomFieldValue23_CLBR}}'},
		{find: '\\[Project.CustomFieldValue24_CLBR\\]', replace: '{{:Project.CustomFieldValue24_CLBR}}'},
		{find: '\\[Project.CustomFieldValue25_CLBR\\]', replace: '{{:Project.CustomFieldValue25_CLBR}}'},
		{find: '\\[Project.CustomFieldValue26_CLBR\\]', replace: '{{:Project.CustomFieldValue26_CLBR}}'},
		{find: '\\[Project.CustomFieldValue27_CLBR\\]', replace: '{{:Project.CustomFieldValue27_CLBR}}'},
		{find: '\\[Project.CustomFieldValue28_CLBR\\]', replace: '{{:Project.CustomFieldValue28_CLBR}}'},
		{find: '\\[Project.CustomFieldValue29_CLBR\\]', replace: '{{:Project.CustomFieldValue29_CLBR}}'},
		{find: '\\[Project.CustomFieldValue30_CLBR\\]', replace: '{{:Project.CustomFieldValue30_CLBR}}'},
		{find: '\\[Project.CustomFieldValue31_CLBR\\]', replace: '{{:Project.CustomFieldValue31_CLBR}}'},
		{find: '\\[Project.CustomFieldValue32_CLBR\\]', replace: '{{:Project.CustomFieldValue32_CLBR}}'},
		{find: '\\[Project.CustomFieldValue33_CLBR\\]', replace: '{{:Project.CustomFieldValue33_CLBR}}'},
		{find: '\\[Project.CustomFieldValue34_CLBR\\]', replace: '{{:Project.CustomFieldValue34_CLBR}}'},
		{find: '\\[Project.CustomFieldValue35_CLBR\\]', replace: '{{:Project.CustomFieldValue35_CLBR}}'},
		{find: '\\[Project.CustomFieldValue36_CLBR\\]', replace: '{{:Project.CustomFieldValue36_CLBR}}'},
		{find: '\\[Project.CustomFieldValue37_CLBR\\]', replace: '{{:Project.CustomFieldValue37_CLBR}}'},
		{find: '\\[Project.CustomFieldValue38_CLBR\\]', replace: '{{:Project.CustomFieldValue38_CLBR}}'},
		{find: '\\[Project.CustomFieldValue39_CLBR\\]', replace: '{{:Project.CustomFieldValue39_CLBR}}'},
		{find: '\\[Project.CustomFieldValue40_CLBR\\]', replace: '{{:Project.CustomFieldValue40_CLBR}}'},
		{find: '\\[ProjectSetupItem.Table\\]', replace: '{{:ProjectSetupItem.Table}}'}];
	_.each(tokens, function (token) {
		template = template.replace(new RegExp(token.find, 'g'), token.replace);
	});
	return template;
}

function toggleTabs(keepEnabledHeaderIdList, enable, optionalIndexArr) {
	var disableArr = [];
	if (optionalIndexArr == null)
		optionalIndexArr = [];
	if (enable) {
		jQuery('#tabsMain').tabs('option', 'disabled', disableArr);
	}
	else {
		jQuery('#tabsMain ul').find('li').each(function (index) {
			if (jQuery(this).attr('id') != null && keepEnabledHeaderIdList.indexOf(jQuery(this).attr('id')) == -1 && optionalIndexArr.indexOf(index) == -1)
				disableArr.push(index);
		});
		jQuery('#tabsMain').tabs('option', 'disabled', disableArr);
	}
}

function activateTab(tabHeader) {
	jQuery('#tabsMain ul').find('li').each(function (index) {
		if (jQuery(this).attr('id') != null && tabHeader.toLowerCase() == jQuery(this).attr('id').toLowerCase()) {
			jQuery(this).find('a').trigger('click');
			jQuery('#tabsMain').tabs('option', 'active', index);
			return false;
		}
	});
}

function getSelectedTabId() {
	return jQuery(jQuery('#tabsMain ul').find('li')[jQuery('#tabsMain').tabs('option', 'active')]).attr('id').toLowerCase();
}